var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 270.5,
    height: 115.749,
    viewBox: "0 0 270.5 115.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "translate(-162.249 2186.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(162.249 -2186.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M166.723-2071.7s-11.761-27.649,2.858-49.041c16.689-24.419,35.547-12.825,48.435-26.882s24.98-42.286,65.574-35.912c17.313,2.718,32.165.856,45.774-1.007,18.3-2.5,34.351-5.009,51.121,3.624,29.242,15.053,10.208,29.594,24.183,39.585s40.049,15.582,21.848,70.165l-259.792-.532",
    transform: "translate(-162.249 2186.917)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M2002.182-1167.562h-23.333v-47.222h23.333v47.222",
    transform: "translate(-1851.788 1282.779)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M1687.038-1463.8H1674.5v-69.5h12.535v69.5",
    transform: "translate(-1568.729 1579.02)",
    fill: "#d2e0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M1877.049-1167.562h-23.333v-47.222h23.333v47.222",
    transform: "translate(-1735.407 1282.779)",
    fill: "#d2e0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M1857.139-1511.025h-3.424V-1533.3h3.424v22.279",
    transform: "translate(-1735.407 1579.02)",
    fill: "#95b1ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M1929.34-1463.92h-16.785v-10.689h16.785v10.689",
    transform: "translate(-1790.132 1524.432)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M1865.34-1463.92h-16.785v-10.689h16.785v10.689",
    transform: "translate(-1730.608 1524.432)",
    fill: "#d2e0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M1951.08-1452.9h-8.071v-1.642h8.071v1.642",
    transform: "translate(-1818.455 1505.769)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M1880.193-1452.9h-2v-1.642h2v1.642",
    transform: "translate(-1758.175 1505.769)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M1880.193-1411.7h-2v-1.643h2v1.643",
    transform: "translate(-1758.175 1467.45)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M1880.193-1370.5h-2v-1.643h2v1.643",
    transform: "translate(-1758.175 1429.132)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M1951.08-1411.7h-8.071v-1.643h8.071v1.643",
    transform: "translate(-1818.455 1467.45)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M1951.08-1370.5h-8.071v-1.643h8.071v1.643",
    transform: "translate(-1818.455 1429.132)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M1739.469-1350.622h-4.286v-21.521h4.286v21.521",
    transform: "translate(-1625.165 1429.132)",
    fill: "#95b1ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M1699.578-1441.25h9v-65.443h-9Zm9.143.143h-9.286v-65.729h9.286v65.729",
    transform: "translate(-1591.919 1554.404)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M1957.417-1447.716h-3.409v-.2h3.409v.2",
    transform: "translate(-1828.685 1499.605)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M1957.417-1441.116h-3.409v-.2h3.409v.2",
    transform: "translate(-1828.685 1493.467)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M1957.417-1406.143h-3.409v-.2h3.409v.2",
    transform: "translate(-1828.685 1460.94)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M1957.417-1399.529h-3.409v-.2h3.409v.2",
    transform: "translate(-1828.685 1454.789)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M1957.417-1358.33h-3.409v-.2h3.409v.2",
    transform: "translate(-1828.685 1416.471)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M1957.417-1365.57h-3.409v-.2h3.409v.2",
    transform: "translate(-1828.685 1423.204)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M1473.058-1788.011c.108-2.629,5.16-9.171,5.16-9.171s1.151,3.312,1.179,3.368c1.039,2.078,2.654,4.813,2.6,6.173a4.626,4.626,0,0,1-4.665,4.576,4.626,4.626,0,0,1-4.272-4.946",
    transform: "translate(-1381.371 1824.442)",
    fill: "#060633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M1524.177-1984.223l-2.967-8.565,24.128-8.361a13.542,13.542,0,0,1,7.268-.447l26.083,5.577-1.895,8.864-26.083-5.577a4.48,4.48,0,0,0-2.405.147l-24.128,8.361",
    transform: "translate(-1426.158 2014.836)",
    fill: "#c0d8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M2648.684-1388.164l-9.118-17.742a6.312,6.312,0,0,0-5.522-3.432l-8.85-.141.051-3.237,8.849.141a9.544,9.544,0,0,1,8.351,5.189l9.118,17.742-2.878,1.48",
    transform: "translate(-2452.925 1466.867)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "M2583.582-1558.523l-18.4,15.918a5.305,5.305,0,0,1-7.343-.388l-21.013-22.462c-4.363-4.665-3.964-15.8,1.167-19.609l9.255-2.945-2.969,6.705a12.561,12.561,0,0,0,2.139,13.482l13.386,14.9a4.093,4.093,0,0,0,5.879.217l12.192-11.7,5.711,5.882",
    transform: "translate(-2367.944 1629.899)",
    fill: "#9db0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M3148.412-1200.13a1.64,1.64,0,0,1,2.226-.652,1.642,1.642,0,0,1,.651,2.227,1.64,1.64,0,0,1-2.226.651,1.64,1.64,0,0,1-.651-2.226",
    transform: "translate(-2939.36 1269.944)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "M2377.118-2032.49l-10.89,10-24.914-25.22a13.931,13.931,0,0,0-4.126-2.882c-.16-.074-.32-.143-.482-.209h0a13.932,13.932,0,0,0-4.4-1.018,6.606,6.606,0,0,0-4.362,1.286l-13.6,12.444-3.76-2.393a4.112,4.112,0,0,1-1.887-3.08l-1.56-16.325-5.235-1.445a2.42,2.42,0,0,1-1.688-2.977l3.292-11.924a3.082,3.082,0,0,1,3.382-2.235l1.079.145a13.442,13.442,0,0,0,1.786.12,13.367,13.367,0,0,0,11.715-6.941,3.316,3.316,0,0,1,3.84-1.589l19.75,5.884c6.818,2.305,6.777,1.489,12.835,7.707l10.673,10.748a8.978,8.978,0,0,1,2.318,8.579l-2.275,8.76,8.6,8.663a2.708,2.708,0,0,1-.091,3.9",
    transform: "translate(-2150.59 2093.867)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "M2472.912-2045.2l-.034.138.132.134-21.342-19.727a16.405,16.405,0,0,0-6.593-3.71l-32.841-9.965a13.443,13.443,0,0,0,1.786.12,13.367,13.367,0,0,0,11.715-6.941,3.316,3.316,0,0,1,3.84-1.589l19.75,5.884c6.818,2.305,6.777,1.489,12.835,7.707l10.673,10.748a8.977,8.977,0,0,1,2.319,8.579l-2.24,8.623",
    transform: "translate(-2254.861 2093.867)",
    fill: "#e88134"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "M2235.074-1945.289l5.575,1.22-2.729,10.262-5.233-1.483,2.386-10",
    transform: "translate(-2087.873 1962.189)",
    fill: "#86a9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M2155.576-1946.2l-.674-.148,2.069-9.357.674.149-2.069,9.356",
    transform: "translate(-2015.527 1971.874)",
    fill: "#86a9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "M2089.629-1960.116l-.674-.149,2.069-9.357.674.149-2.068,9.357",
    transform: "translate(-1954.193 1984.82)",
    fill: "#86a9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M2023.843-1974.624l-.674-.149,2.068-9.355.675.149-2.069,9.356",
    transform: "translate(-1893.008 1998.312)",
    fill: "#86a9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M1957.709-1987.877l-.674-.148,2.068-9.357.674.149-2.068,9.356",
    transform: "translate(-1831.5 2010.639)",
    fill: "#86a9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M2429.938-1692.03a13.918,13.918,0,0,0-4.4-1.019,6.606,6.606,0,0,0-4.362,1.286l-12.046,13.546a1.771,1.771,0,0,1-2.6.046l-3.034-3.178a5.752,5.752,0,0,1-1.567-3.427l-1.561-16.341s24.958,5.993,29.57,9.086",
    transform: "translate(-2243.824 1735.095)",
    fill: "#e88134"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "M1417.917-1484.773a5.449,5.449,0,0,1,5.449-5.45,5.449,5.449,0,0,1,5.449,5.45,5.449,5.449,0,0,1-5.449,5.449,5.449,5.449,0,0,1-5.449-5.449",
    transform: "translate(-1330.09 1538.953)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "M1432.207-1480.592a4.678,4.678,0,0,0-4.672,4.673,4.678,4.678,0,0,0,4.672,4.672,4.678,4.678,0,0,0,4.672-4.672A4.678,4.678,0,0,0,1432.207-1480.592Zm0,9.456a4.79,4.79,0,0,1-4.784-4.783,4.79,4.79,0,0,1,4.784-4.784,4.789,4.789,0,0,1,4.784,4.784,4.789,4.789,0,0,1-4.784,4.783",
    transform: "translate(-1338.932 1530.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M1465.326-1463.017a.824.824,0,0,0-.043-.295.613.613,0,0,0-.15-.233,1.174,1.174,0,0,0-.274-.195,2.959,2.959,0,0,0-.411-.177c-.278-.1-.532-.21-.758-.32a2.569,2.569,0,0,1-.582-.382,1.516,1.516,0,0,1-.372-.5,1.559,1.559,0,0,1-.125-.675,1.534,1.534,0,0,1,.129-.616,1.445,1.445,0,0,1,.35-.48,1.793,1.793,0,0,1,.539-.329,2.386,2.386,0,0,1,.7-.155l.013-.851.685.009-.012.865a2.125,2.125,0,0,1,.665.2,1.669,1.669,0,0,1,.506.39,1.658,1.658,0,0,1,.315.56,2.118,2.118,0,0,1,.1.72l-1.239-.018a1.046,1.046,0,0,0-.2-.718.727.727,0,0,0-.565-.245.926.926,0,0,0-.333.049.63.63,0,0,0-.231.144.588.588,0,0,0-.136.219.868.868,0,0,0-.046.274.784.784,0,0,0,.039.268.583.583,0,0,0,.145.223,1.166,1.166,0,0,0,.276.195,3.944,3.944,0,0,0,.428.191q.412.162.752.33a2.61,2.61,0,0,1,.58.384,1.535,1.535,0,0,1,.372.5,1.546,1.546,0,0,1,.125.671,1.559,1.559,0,0,1-.132.628,1.408,1.408,0,0,1-.352.477,1.732,1.732,0,0,1-.543.319,2.583,2.583,0,0,1-.7.149l-.012.792-.681-.009.011-.789a2.846,2.846,0,0,1-.686-.165,1.828,1.828,0,0,1-.585-.353,1.633,1.633,0,0,1-.4-.573,1.988,1.988,0,0,1-.143-.823l1.239.018a1.216,1.216,0,0,0,.073.473.788.788,0,0,0,.208.306.771.771,0,0,0,.3.164,1.344,1.344,0,0,0,.345.05,1.115,1.115,0,0,0,.354-.047.713.713,0,0,0,.256-.14.573.573,0,0,0,.158-.215.7.7,0,0,0,.055-.272",
    transform: "translate(-1371.405 1518.492)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "M1500.917-1290.437a3.733,3.733,0,0,1,3.734-3.733,3.734,3.734,0,0,1,3.734,3.733,3.734,3.734,0,0,1-3.734,3.734,3.734,3.734,0,0,1-3.734-3.734",
    transform: "translate(-1407.284 1356.613)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "M1510.714-1287.587a3.205,3.205,0,0,0-3.2,3.2,3.206,3.206,0,0,0,3.2,3.2,3.206,3.206,0,0,0,3.2-3.2A3.205,3.205,0,0,0,1510.714-1287.587Zm0,6.48a3.282,3.282,0,0,1-3.278-3.278,3.282,3.282,0,0,1,3.278-3.278,3.282,3.282,0,0,1,3.278,3.278,3.281,3.281,0,0,1-3.278,3.278",
    transform: "translate(-1413.348 1350.561)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M1533.4-1275.536a.566.566,0,0,0-.029-.2.42.42,0,0,0-.1-.16.809.809,0,0,0-.187-.133,2.21,2.21,0,0,0-.282-.121,5.532,5.532,0,0,1-.52-.219,1.731,1.731,0,0,1-.4-.261,1.024,1.024,0,0,1-.255-.342,1.041,1.041,0,0,1-.086-.462,1.063,1.063,0,0,1,.088-.423.994.994,0,0,1,.24-.329,1.221,1.221,0,0,1,.369-.225,1.61,1.61,0,0,1,.479-.106l.009-.584.47.006-.009.592a1.462,1.462,0,0,1,.457.14,1.134,1.134,0,0,1,.345.268,1.121,1.121,0,0,1,.216.383,1.446,1.446,0,0,1,.071.493l-.849-.012a.716.716,0,0,0-.138-.491.5.5,0,0,0-.387-.168.614.614,0,0,0-.229.034.43.43,0,0,0-.159.1.407.407,0,0,0-.093.15.588.588,0,0,0-.032.188.543.543,0,0,0,.026.183.4.4,0,0,0,.1.153.779.779,0,0,0,.188.133,2.462,2.462,0,0,0,.294.131q.283.11.515.226a1.786,1.786,0,0,1,.4.264,1.066,1.066,0,0,1,.255.343,1.069,1.069,0,0,1,.086.46,1.07,1.07,0,0,1-.09.43.964.964,0,0,1-.242.326,1.186,1.186,0,0,1-.371.219,1.779,1.779,0,0,1-.482.1l-.008.543-.467-.007.008-.54a1.955,1.955,0,0,1-.469-.114,1.26,1.26,0,0,1-.4-.242,1.126,1.126,0,0,1-.276-.392,1.375,1.375,0,0,1-.1-.564l.849.013a.831.831,0,0,0,.05.323.549.549,0,0,0,.142.21.544.544,0,0,0,.206.112.885.885,0,0,0,.236.035.745.745,0,0,0,.243-.032.484.484,0,0,0,.176-.1.4.4,0,0,0,.108-.146.488.488,0,0,0,.037-.187",
    transform: "translate(-1435.594 1342.6)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "M1414.29-1134.737a2.513,2.513,0,0,1,2.513-2.513,2.513,2.513,0,0,1,2.513,2.513,2.513,2.513,0,0,1-2.513,2.512,2.513,2.513,0,0,1-2.513-2.512",
    transform: "translate(-1326.717 1210.669)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M1420.883-1132.812a2.158,2.158,0,0,0-2.155,2.155,2.157,2.157,0,0,0,2.155,2.154,2.157,2.157,0,0,0,2.155-2.154A2.158,2.158,0,0,0,1420.883-1132.812Zm0,4.362a2.21,2.21,0,0,1-2.207-2.206,2.209,2.209,0,0,1,2.207-2.206,2.209,2.209,0,0,1,2.207,2.206,2.21,2.21,0,0,1-2.207,2.207",
    transform: "translate(-1330.797 1206.589)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "M1436.159-1124.7a.386.386,0,0,0-.02-.136.292.292,0,0,0-.069-.108.53.53,0,0,0-.127-.089,1.421,1.421,0,0,0-.189-.082,3.473,3.473,0,0,1-.35-.147,1.2,1.2,0,0,1-.269-.175.7.7,0,0,1-.172-.23.714.714,0,0,1-.058-.312.712.712,0,0,1,.06-.284.663.663,0,0,1,.161-.222.812.812,0,0,1,.248-.151,1.077,1.077,0,0,1,.323-.072l.006-.393.316,0-.005.4a.969.969,0,0,1,.307.094.762.762,0,0,1,.233.18.749.749,0,0,1,.145.258.985.985,0,0,1,.048.332l-.572-.008a.482.482,0,0,0-.093-.331.33.33,0,0,0-.26-.113.426.426,0,0,0-.153.022.289.289,0,0,0-.107.066.279.279,0,0,0-.062.1.367.367,0,0,0-.022.126.346.346,0,0,0,.018.123.264.264,0,0,0,.066.1.554.554,0,0,0,.128.09,1.753,1.753,0,0,0,.2.089q.191.074.346.152a1.19,1.19,0,0,1,.268.177.694.694,0,0,1,.172.231.705.705,0,0,1,.058.31.71.71,0,0,1-.061.289.667.667,0,0,1-.162.22.82.82,0,0,1-.25.146,1.2,1.2,0,0,1-.325.069l-.006.365-.314,0,.005-.364a1.306,1.306,0,0,1-.316-.077.847.847,0,0,1-.269-.162.761.761,0,0,1-.187-.265.921.921,0,0,1-.065-.38l.572.008a.552.552,0,0,0,.032.218.374.374,0,0,0,.1.141.355.355,0,0,0,.138.076.615.615,0,0,0,.159.024.512.512,0,0,0,.163-.022.325.325,0,0,0,.118-.064.268.268,0,0,0,.073-.1.308.308,0,0,0,.025-.125",
    transform: "translate(-1345.775 1201.232)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "M1073.54-848.984h86.647l29.263-2.635s-5.237-13.047-6.663-13.243-106.5,0-106.5,0l-2.745,15.878",
    transform: "translate(-1009.801 957.413)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "M1061.455-1145.637c-2.157.882-15.191,1.078-15.191,1.078s.294-15.974-13.133-14.112-11.079,15.12-11.079,15.12L957.5-1142.4s1.048-16.84-13.2-15.069c-11.841,1.472-8.8,15.005-8.8,15.005-11.8.611-13.024-3.4-13.024-3.4v-1.655h.74v-4.356h-.74v-3.245l2.483-5.684h0c4.183-7.187,36.981-9.147,36.981-9.147,4.981-2.863,9.111-4.991,12.342-6.537,5.153-2.466,11.029-4.87,16.715-5.432a128.928,128.928,0,0,1,31.158.706c3.626.588,21.854,8.526,23.226,9.212s12.563,1.616,14,1.791a1.569,1.569,0,0,1,1.394,1.611l.2,1.275.751,4.858.183,1.185a2.42,2.42,0,0,1,1.047,2.02s.655,12.74-1.5,13.622",
    transform: "translate(-869.303 1252.782)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "M1119.66-806.551a9.94,9.94,0,0,1,9.94-9.94,9.94,9.94,0,0,1,9.939,9.94,9.94,9.94,0,0,1-9.939,9.94,9.94,9.94,0,0,1-9.94-9.94",
    transform: "translate(-1052.695 912.345)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "M1158.407-784.787a7.063,7.063,0,0,0-7.055,7.055,7.062,7.062,0,0,0,7.055,7.054,7.063,7.063,0,0,0,7.055-7.054A7.063,7.063,0,0,0,1158.407-784.787Zm0,14.828a7.782,7.782,0,0,1-7.773-7.773,7.782,7.782,0,0,1,7.773-7.773,7.782,7.782,0,0,1,7.773,7.773,7.782,7.782,0,0,1-7.773,7.773",
    transform: "translate(-1081.501 883.525)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M1242.011-766.168h-2.785l.894-7.633-1.022-7.25,3.183.2-1.061,7.053.791,7.633",
    transform: "translate(-1163.779 879.384)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "M1160.637-737.594l-1.392-2.413,7.058-3.041,5.768-4.51,1.421,2.856-6.64,2.607-6.216,4.5",
    transform: "translate(-1089.511 848.233)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M1163.187-746.445l1.53-2.327,5.887,4.941,6.619,3.13-1.913,2.552L1170-742.911l-6.812-3.534",
    transform: "translate(-1093.177 849.361)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "M1224.472-709.058a2.593,2.593,0,0,1,2.593-2.594,2.594,2.594,0,0,1,2.594,2.594,2.594,2.594,0,0,1-2.594,2.594,2.593,2.593,0,0,1-2.593-2.594",
    transform: "translate(-1150.175 814.838)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "M2379.754-806.551a9.94,9.94,0,0,1,9.94-9.94,9.94,9.94,0,0,1,9.939,9.94,9.939,9.939,0,0,1-9.939,9.94,9.94,9.94,0,0,1-9.94-9.94",
    transform: "translate(-2224.653 912.345)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "M2418.5-784.787a7.063,7.063,0,0,0-7.054,7.055,7.062,7.062,0,0,0,7.054,7.054,7.063,7.063,0,0,0,7.055-7.054A7.064,7.064,0,0,0,2418.5-784.787Zm0,14.828a7.782,7.782,0,0,1-7.773-7.773,7.782,7.782,0,0,1,7.773-7.773,7.782,7.782,0,0,1,7.773,7.773,7.782,7.782,0,0,1-7.773,7.773",
    transform: "translate(-2253.46 883.525)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M2502.106-766.168h-2.784l.894-7.633-1.021-7.25,3.183.2-1.061,7.053.791,7.633",
    transform: "translate(-2335.738 879.384)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "M2420.733-737.594l-1.392-2.413,7.058-3.041,5.768-4.51,1.421,2.856-6.639,2.607-6.216,4.5",
    transform: "translate(-2261.47 848.233)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M2423.274-746.445l1.53-2.327,5.887,4.941,6.618,3.13-1.913,2.552-5.311-4.762-6.812-3.534",
    transform: "translate(-2265.129 849.361)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    d: "M2484.567-709.058a2.593,2.593,0,0,1,2.594-2.594,2.593,2.593,0,0,1,2.593,2.594,2.593,2.593,0,0,1-2.593,2.594,2.594,2.594,0,0,1-2.594-2.594",
    transform: "translate(-2322.135 814.838)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "M951.242-674.372h-2.219a2.028,2.028,0,0,0-1.77,1.038l-.076.136a.206.206,0,0,0,.18.307h2.671a.661.661,0,0,0,.485-.213l.871-.944a.193.193,0,0,0-.142-.324",
    transform: "translate(-892.251 780.165)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "M2085.294-1136.986l-33.181.788a1.158,1.158,0,0,1-1.185-1.158V-1145a1.078,1.078,0,0,1,1.094-1.078c14.148.2,19,.591,21.905,1.595,2.565.884,8.563,4.523,11.663,6.369a.607.607,0,0,1-.3,1.129",
    transform: "translate(-1918.826 1218.879)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M1599.329-1146.818l1.581.019v9.971l-32.01.759a.418.418,0,0,1-.243-.764c3.74-2.521,16.267-10.149,30.673-9.985",
    transform: "translate(-1470.114 1219.569)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    d: "M2540.412-1034.465h-.018v-1.386l.331.2a.64.64,0,0,1-.312,1.189",
    transform: "translate(-2374.056 1116.361)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "M1998.8-1144.13l-3.92-.311.261-10.663h3.66v10.974",
    transform: "translate(-1866.694 1227.273)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "M2381.584-1125.541h-1.829v-9.576l1.829,1.1v8.478",
    transform: "translate(-2224.653 1208.684)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "M1569.354-1041.011l.976,3.233-5.34.127a.317.317,0,0,1-.193-.575,25.376,25.376,0,0,1,4.557-2.786",
    transform: "translate(-1466.574 1121.16)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "M1564.151-1142.536l-.181.1q-.316.176-.615.348l-.27.155c-.284.165-.558.325-.812.479-.091.054-.18.107-.267.161l-.185.112-.117.072-.027.018c-.12.073-.236.144-.348.215l-.075.046-.378.24q-.255.162-.481.311l-.2.133c-.131.087-.256.17-.372.248-.14.094-.268.181-.382.261l-.053.036,5.5-.13,23.7-.562a.757.757,0,0,0,.735-.753v-8.263a.516.516,0,0,0-.157-.371.518.518,0,0,0-.377-.147l-.214.007-.182.006-.215.009h-.008l-.243.011c-.1,0-.2.009-.3.016l-.04,0-.269.016-.461.032-.236.018-.313.026-.322.029-.239.023c-.074.007-.143.014-.212.022s-.139.013-.205.021c-.1.01-.19.021-.284.031l-.021,0c-.336.039-.68.083-1.021.13l-.549.079-.015,0-.312.048q-.312.049-.619.1l-.1.018-.21.036-.327.06-.289.055-.29.057-.017,0c-.1.021-.2.04-.3.062l-.306.063-.3.065-.3.066-.223.051-.078.018c-.1.022-.2.046-.3.07-.168.039-.333.079-.5.12l-.1.024-.024.006c-.382.1-.768.2-1.146.3-.192.052-.381.105-.571.16l-.3.087c-.179.052-.36.106-.54.16l-.35.108-.509.16-.276.09-.011,0-.265.087-.328.11-.258.088-.23.08c-1.048.366-2.106.768-3.143,1.195l-.461.191c-.294.124-.557.237-.8.346l-.249.11-.49.218-.242.11c-.242.111-.479.22-.712.331l-.234.111c-.748.356-1.5.73-2.222,1.112l-.177.093-.125.066C1564.849-1142.917,1564.5-1142.728,1564.151-1142.536Zm-4.833,3.459a.5.5,0,0,1-.476-.346.5.5,0,0,1,.189-.568l.112-.077c.115-.08.244-.169.387-.265.117-.079.243-.162.376-.251l.2-.132c.153-.1.315-.205.488-.315l.381-.242.021-.013.057-.035.348-.215.026-.016c.039-.025.08-.05.12-.074l.186-.114.269-.161c.256-.154.532-.317.819-.483l.271-.156q.271-.157.558-.316h0l.135-.076c.385-.214.776-.427,1.161-.631l.127-.067.176-.093c.734-.384,1.488-.762,2.243-1.122l.234-.111q.354-.167.717-.333c.08-.037.162-.075.245-.111.161-.074.326-.147.493-.221l.25-.11c.249-.11.515-.224.811-.349l.464-.193c1.046-.432,2.113-.836,3.17-1.2l.231-.08.262-.09.33-.11.268-.089.01,0,.281-.091.512-.161c.118-.037.236-.073.354-.109l.546-.163.3-.087q.287-.083.576-.161c.382-.105.771-.207,1.156-.3l.023-.005.1-.026.5-.121.3-.071.076-.017.227-.052.3-.067.306-.065.308-.064.309-.062.016,0,.293-.057.292-.056.331-.06.213-.038.1-.017q.312-.055.626-.1l.315-.049.016,0,.556-.08c.345-.048.693-.091,1.032-.132l.022,0c.1-.011.19-.022.286-.032.066-.009.137-.016.206-.022s.142-.016.216-.022l.242-.023.325-.03c.1-.008.208-.018.313-.025l.243-.02.464-.031.275-.017.04,0,.306-.016.245-.011h.008l.22-.009.182-.006.217-.006a1.029,1.029,0,0,1,.755.295,1.032,1.032,0,0,1,.315.746v8.263a1.282,1.282,0,0,1-1.245,1.275l-29.263.695h-.013",
    transform: "translate(-1461.135 1222.852)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "M2403.422-1113.858a.334.334,0,0,0-.172.05.428.428,0,0,0-.192.37v5.579a.392.392,0,0,0,.113.281.288.288,0,0,0,.21.086l9.068-.235a.29.29,0,0,0,.262-.227.347.347,0,0,0-.132-.392l-.019-.013-.061-.039-.442-.287-.88-.568-.737-.471c-.1-.067-.211-.135-.318-.2-2.506-1.593-4.476-2.784-5.857-3.538l-.112-.061-.034-.019c-.1-.054-.29-.15-.554-.28A.315.315,0,0,0,2403.422-1113.858Zm-.05,6.829a.747.747,0,0,1-.525-.217.857.857,0,0,1-.254-.613v-5.579c0-.318.047-.723.3-.883a1.014,1.014,0,0,1,.87.081c.272.134.463.23.566.285l.041.023.111.061c1.391.759,3.37,1.955,5.884,3.553l.319.2c.254.162.5.32.738.473l.882.569.44.286.063.04.019.013a.808.808,0,0,1,.324.907.742.742,0,0,1-.7.562l-.1,0-8.972.233h-.02",
    transform: "translate(-2245.895 1189.408)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "M1569.354-1041.011l.976,3.233-5.34.127a.317.317,0,0,1-.193-.575,25.376,25.376,0,0,1,4.557-2.786",
    transform: "translate(-1466.574 1121.16)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "M2048.522-1149.289a.811.811,0,0,0-.574.236.808.808,0,0,0-.243.581v7.644a.89.89,0,0,0,.27.642.883.883,0,0,0,.647.254l21.56-.511v-7.33c-2.791-.99-7.577-1.321-21.648-1.516Zm.077,9.881a1.41,1.41,0,0,1-.989-.4,1.409,1.409,0,0,1-.428-1.016v-7.644a1.329,1.329,0,0,1,.4-.953,1.341,1.341,0,0,1,.96-.386c14.6.2,19.126.534,22,1.611l.169.063v8.2l-22.069.524h-.036",
    transform: "translate(-1915.342 1222.351)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "M2765.917-960.233h-6.247a3.034,3.034,0,0,1-2.383-1.156l-2.362-3a.432.432,0,0,1,.34-.7h9.9l.751,4.858",
    transform: "translate(-2573.496 1050.551)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "M2023.163-1114.465l-.261,0,.392-33.476.262,0-.393,33.476",
    transform: "translate(-1892.76 1220.614)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    d: "M1421.4-674.7l-.006-.261,64.581-1.274.005.261L1421.4-674.7",
    transform: "translate(-1333.327 781.902)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M1879.651-913.33c0,.354-1.579.642-3.528.642s-3.528-.287-3.528-.642,1.58-.641,3.528-.641,3.528.287,3.528.641",
    transform: "translate(-1752.967 1003.006)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "M2349.45-913.33c0,.354-1.58.642-3.528.642s-3.528-.287-3.528-.642,1.579-.641,3.528-.641,3.528.287,3.528.641",
    transform: "translate(-2189.906 1003.006)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M2305.282-992.171l-.261-.014a14.262,14.262,0,0,1,2.931-8.336,13.851,13.851,0,0,1,5.675-4.109,21.494,21.494,0,0,1,7.857-1.493v-9.954h.261v10.224l-.136-.006a21.15,21.15,0,0,0-7.891,1.474,13.578,13.578,0,0,0-5.565,4.031,14.008,14.008,0,0,0-2.871,8.184",
    transform: "translate(-2155.146 1097.971)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    d: "M1533.789-973.228a139.647,139.647,0,0,1,.8-18.1,42.54,42.54,0,0,1,.95-5.577l.252.071c-.02.069-1.935,7.118-1.741,23.6l-.262,0",
    transform: "translate(-1437.846 1080.139)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "M1998.588-1147.683h-5.112v-.261h5.112v.261",
    transform: "translate(-1865.391 1220.614)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "M722.52-628.328a4.51,4.51,0,0,1,.9-3.717,4.071,4.071,0,0,1,3.817-1.34s.335.517-.329.924-2.974-.409-3.557,3.605c0,0-.278.83-.829.528",
    transform: "translate(-683.246 742.102)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M466.827-959.251a.854.854,0,0,1,.854-.853.854.854,0,0,1,.854.853.854.854,0,0,1-.854.854.854.854,0,0,1-.854-.854",
    transform: "translate(-445.523 1045.913)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "M762.455-592.227a1.2,1.2,0,0,1,1.2-1.2,1.2,1.2,0,0,1,1.2,1.2,1.2,1.2,0,0,1-1.2,1.2,1.2,1.2,0,0,1-1.2-1.2",
    transform: "translate(-720.475 704.881)",
    fill: "#7a96e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M382.7-613.751a1.834,1.834,0,0,1,1.834-1.834,1.834,1.834,0,0,1,1.834,1.834,1.835,1.835,0,0,1-1.834,1.834,1.835,1.835,0,0,1-1.834-1.834",
    transform: "translate(-367.281 725.491)",
    fill: "#7a96e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "M409.068-915.252l-.725-.1,2.909-21.232.725.1-2.908,21.232",
    transform: "translate(-391.13 1024.038)",
    fill: "#7a96e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M424.384-947.841v-.821l3.733-.816.245.689-3.978.947",
    transform: "translate(-406.049 1036.029)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    d: "M364.364-636.561a2.727,2.727,0,0,0-2.725,2.725,2.727,2.727,0,0,0,2.725,2.724,2.727,2.727,0,0,0,2.725-2.724A2.727,2.727,0,0,0,364.364-636.561Zm0,6.14a3.419,3.419,0,0,1-3.416-3.415,3.42,3.42,0,0,1,3.416-3.416,3.42,3.42,0,0,1,3.416,3.416,3.419,3.419,0,0,1-3.416,3.415",
    transform: "translate(-347.051 745.642)",
    fill: "#9db0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    d: "M746.4-611.407a1.978,1.978,0,0,0-1.947,2,1.978,1.978,0,0,0,1.947,2,1.978,1.978,0,0,0,1.947-2A1.978,1.978,0,0,0,746.4-611.407Zm0,4.573a2.536,2.536,0,0,1-2.5-2.569,2.536,2.536,0,0,1,2.5-2.568,2.536,2.536,0,0,1,2.5,2.568,2.536,2.536,0,0,1-2.5,2.569",
    transform: "translate(-703.22 722.13)",
    fill: "#9db0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    d: "M494.157-573.98H477.2a.552.552,0,0,1-.551-.551v-.264a.552.552,0,0,1,.551-.55h16.954a.552.552,0,0,1,.551.55v.264a.552.552,0,0,1-.551.551",
    transform: "translate(-454.662 688.065)",
    fill: "#7a96e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    d: "M726.09-578.5a.275.275,0,0,1-.26-.187.275.275,0,0,1,.174-.348l3.487-1.164a.275.275,0,0,1,.347.173.275.275,0,0,1-.173.348l-3.487,1.163a.258.258,0,0,1-.087.015",
    transform: "translate(-686.397 692.592)",
    fill: "#7a96e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    d: "M423.291-731.687l5.844,9.348h1.484L423.6-733.425l-.31,1.737",
    transform: "translate(-405.033 835.088)",
    fill: "#7a96e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    d: "M370.591-633.475l-.536-.163-.56,1.837a1.351,1.351,0,0,1-1.4.951L366.317-631l-.047.558,1.78.15a2.375,2.375,0,0,1,1.8,1.088l.942,1.474.472-.3-.91-1.424a2.7,2.7,0,0,1-.307-2.237l.543-1.783",
    transform: "translate(-352 742.281)",
    fill: "#9db0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190",
    d: "M753.742-605.039l-.348-.106-.364,1.194a.878.878,0,0,1-.913.618l-1.153-.1-.031.363,1.156.1a1.543,1.543,0,0,1,1.171.707l.612.958.307-.2-.591-.925a1.753,1.753,0,0,1-.2-1.454l.353-1.158",
    transform: "translate(-709.759 715.781)",
    fill: "#9db0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    d: "M774.95-580.577a.275.275,0,0,1,.275-.275.275.275,0,0,1,.275.275.275.275,0,0,1-.275.274.275.275,0,0,1-.275-.274",
    transform: "translate(-732.095 693.187)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    d: "M405-593.017a.275.275,0,0,1,.275-.275.275.275,0,0,1,.275.275.275.275,0,0,1-.275.274.275.275,0,0,1-.275-.274",
    transform: "translate(-388.021 704.757)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    d: "M378.9-648.506a4.507,4.507,0,0,1,3.8-.4,4.069,4.069,0,0,1,2.542,3.147s-.374.488-.981,0-.611-2.94-4.588-2.143c0,0-.875.016-.775-.6",
    transform: "translate(-363.738 756.706)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    d: "M559.813-1239.677s-2.765,4.446-2.765,5.651a5.909,5.909,0,0,0,.881,2.594l2.8-2.322,1.392-2.5-2.305-3.426",
    transform: "translate(-529.434 1305.931)",
    fill: "#829ce8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    d: "M581.348-1180.545a2.687,2.687,0,0,1-2.6,1.382,4.784,4.784,0,0,1-.613-1.334c-.015-.074-.03-.144-.044-.211-.14-.668-.236-1.039-.236-1.039h0c.065-.043,2.177-1.437,2.19-1.359a4.155,4.155,0,0,0,1.3,2.561",
    transform: "translate(-548.785 1253.32)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    d: "M563.453-1218.293s2.565.859,3.075-.747,1.185-2.576-.431-3.192-2.131-.1-2.431.39-.867,3.285-.213,3.549",
    transform: "translate(-535.11 1289.969)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204",
    d: "M525.884-605.543h4.227a.363.363,0,0,0,.09-.026c.282-.141.194-1.222.16-1.556-.007-.062-.011-.1-.011-.1s-1.486-1.188-1.691-.279c-.006.029-.014.057-.022.084h0c-.258.851-1.411,1.239-2.077,1.346a.726.726,0,0,0-.675.528",
    transform: "translate(-500.45 718.291)",
    fill: "#a9453d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206",
    d: "M644.168-605.543h4.226a.362.362,0,0,0,.09-.026c.282-.141.194-1.222.16-1.556-.006-.062-.011-.1-.011-.1s-1.486-1.188-1.691-.279c-.006.029-.014.057-.022.084h0c-.258.851-1.411,1.239-2.077,1.346a.726.726,0,0,0-.675.528",
    transform: "translate(-610.46 718.291)",
    fill: "#a9453d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    d: "M538.064-928.594s.226,2.815.491,6.2c.361,4.6.794,10.246.837,11.316.074,1.859.573,4.981.573,4.981s.3.492,1.713.195a39.355,39.355,0,0,0,1.822-8.668c.005-.074.011-.148.017-.222.334-4.57.854-14.193.854-14.193l-6.306.391",
    transform: "translate(-511.778 1016.97)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path210",
    d: "M538.064-928.594s.226,2.815.491,6.2l4.944,7.823c.005-.074.011-.148.017-.222.334-4.57.854-14.193.854-14.193l-6.306.391",
    transform: "translate(-511.778 1016.97)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    d: "M552.8-943.079s2.772,10.616,5.447,15.408,3.63,6.926,3.63,6.926,1.639.442,1.778.024c0,0-1.4-11.407-2.487-14.075-.562-1.382-.825-5.627-.88-6.965a9.661,9.661,0,0,0-1-3.159l-6.492,1.839",
    transform: "translate(-525.483 1031.788)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path214",
    d: "M534.988-1121.614c5.143,2.545,10.774,1.722,10.763,1.546-.009-.191-2.143-11.539-2.882-14.849-.688-3.082-1.618-5.783-2.479-6.4-.113-.077-.791.271-1.413.593a2.6,2.6,0,0,1-1.707.242,4.044,4.044,0,0,0-.444.774,59.47,59.47,0,0,0-2.176,7.606c0,.06,0,.118,0,.178-.006.288-.012.578-.016.865,0,.329.3,9.415.358,9.443",
    transform: "translate(-508.584 1214.46)",
    fill: "#9db0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path216",
    d: "M534.678-1045.936c5.059-2.837,4.558-9.368,4.558-9.368l-4.723,4.253q-.007.494-.009.978,0,.364,0,.718v.032c-.006.088,0,.184,0,.271,0,.4.167,2.756.173,3.116",
    transform: "translate(-508.466 1134.454)",
    fill: "#7a96e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    d: "M462.373-1104.767c-.252-.436-.055-.625-.055-.625s4.178-3.068,4.507-3.38a54.37,54.37,0,0,0,1.969-5.405s.574-2.064,1.775-2.257a2.187,2.187,0,0,1,2.2.985,2.212,2.212,0,0,1,.073,2.492,58.882,58.882,0,0,1-3.936,5.719c-1.406,1.282-5.938,2.826-5.938,2.826a.752.752,0,0,1-.591-.353",
    transform: "translate(-441.262 1191.338)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220",
    d: "M557.305-1235.751c.034.026.582.252,1.847-1.778a1.862,1.862,0,0,0,.048-1.706c-.332-.675-1.672-1.306-2.8-1.63s-1.468.3-1.8.924a3.532,3.532,0,0,1-1.222,1.144c.942.646,2.212-.036,2.614.132s.488.835.5,1.047.044.391.582.252.167.76.068.93c0,0-.114.464.167.684",
    transform: "translate(-526.018 1307.118)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path222",
    d: "M574.057-1239.677a12.552,12.552,0,0,1,1.459,3.45c.045,1.033-3.153,4.274-3.153,4.274s2.742.72,3.871,0c0,0,2.609-3.635,2.609-4.3a4.922,4.922,0,0,0-4.787-3.426",
    transform: "translate(-543.679 1305.931)",
    fill: "#9db0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224",
    d: "M560.891-924.811a17.036,17.036,0,0,0,4.042.178l-.035,2.495-1.986.761-2.021-1.121v-2.313",
    transform: "translate(-533.008 1013.088)",
    fill: "#7a96e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226",
    d: "M429.016-958.144a5.44,5.44,0,0,0-1.921.381c-.32.3-.95.871-.475.972l1.149-.252c.587.139.8.457,1.173.259l.783-.417-.709-.944",
    transform: "translate(-407.97 1044.09)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path228",
    d: "M408.343-944.931a.854.854,0,0,1,.854-.853.854.854,0,0,1,.854.853.854.854,0,0,1-.854.854.854.854,0,0,1-.854-.854",
    transform: "translate(-391.13 1032.594)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    d: "M635.361-1122.161a1.721,1.721,0,0,1-.047.324c-.335,1.282-4.674,2.25-5.16,1.787a1.855,1.855,0,0,1-.281-.371c-1.235-2.031-2.8-9.427-2.185-8.988a12.425,12.425,0,0,1,2.1-.45l.167-.013h.006a1.993,1.993,0,0,1,.759.068c.807.3,1.451,2.406,1.451,2.406a5.584,5.584,0,0,1,1.257-.021c.073.008.145.021.214.034h0a1.269,1.269,0,0,1,.469.185c.506.362,1.338,3.652,1.25,5.04",
    transform: "translate(-595.003 1203.813)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    d: "M576.909-1138.279a4.607,4.607,0,0,0-3.979-.915l-.567.595s2.5-.6,3.878.713l.667-.394",
    transform: "translate(-543.679 1212.578)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path234",
    d: "M568.925-1027.851s1.488,2.641,5.549,1.33l.416.992s-4.829,1.373-6.459-1.286l.494-1.036",
    transform: "translate(-540.021 1108.921)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path236",
    d: "M487.781-1121.845a1.383,1.383,0,0,0-1.411.843,29.914,29.914,0,0,1-2.249,6.261,19.283,19.283,0,0,1-3.512,3.449s.317,1.021,1,1.293a6.914,6.914,0,0,0,5.468-2.133c.62-.7,4.309-6.711,3.549-7.952a5.362,5.362,0,0,0-2.844-1.761",
    transform: "translate(-458.342 1196.344)",
    fill: "#9db0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path238",
    d: "M655.681-1129.784a1.39,1.39,0,0,0-.34,1.24,6.543,6.543,0,0,0,.442,1.664l-.108.05a6.661,6.661,0,0,1-.452-1.7,1.573,1.573,0,0,1,.284-1.242l.173-.014",
    transform: "translate(-620.724 1203.724)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path240",
    d: "M705.549-1089.429l-.113.036a29.188,29.188,0,0,1-1.123-4.561.964.964,0,0,1,.506-.764c.073.008.145.021.214.035a.856.856,0,0,0-.6.743,30.344,30.344,0,0,0,1.118,4.511",
    transform: "translate(-666.395 1171.11)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path242",
    d: "M648.06-1050.913l1.025,2.907a4.545,4.545,0,0,0,2.288-.551l-.947-2.987a4.2,4.2,0,0,1-2.367.631",
    transform: "translate(-614.08 1130.957)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path244",
    d: "M666.266-1019.531a1.723,1.723,0,0,1-.047.325c-.335,1.282-4.674,2.25-5.16,1.787a1.858,1.858,0,0,1-.281-.371,13.332,13.332,0,0,0,5.488-1.74",
    transform: "translate(-625.908 1101.183)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path246",
    d: "M648.06-1050.913l.3.853,1.355.093.974-.745-.264-.833a20.774,20.774,0,0,0-2.367.631",
    transform: "translate(-614.08 1130.957)",
    fill: "#ef873a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path248",
    d: "M668.832-1033.792a.085.085,0,0,1,.086-.086.085.085,0,0,1,.085.086.085.085,0,0,1-.085.086.086.086,0,0,1-.086-.086",
    transform: "translate(-633.399 1114.526)",
    fill: "#131375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path250",
    d: "M566.223-1177.517a1.406,1.406,0,0,1,.048.3c0,.105.412.215.51.183a1.023,1.023,0,0,0,.3-.265,6.24,6.24,0,0,0-.859-.216",
    transform: "translate(-537.967 1248.119)",
    fill: "#fffefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path252",
    d: "M1188.287-578.436s-.13,2.116.261,2.309l4.982-.273s0-.578-.8-.707-2.219-.6-2.458-1.65-1.98.321-1.98.321",
    transform: "translate(-1116.502 691.607)",
    fill: "#101a30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path254",
    d: "M980.365-578.436s-.16,1.853.231,2.046l5.012.263a.991.991,0,0,0-.8-.98c-.8-.129-2.219-.6-2.458-1.65s-1.98.321-1.98.321",
    transform: "translate(-923.113 691.607)",
    fill: "#101a30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path256",
    d: "M1095.883-954.578a4.765,4.765,0,0,1-2.78.43,60.01,60.01,0,0,1-3.229-10.374c-.019-.094-.039-.188-.058-.284-.285-1.4-.633-3.18-1-5.071-.641-3.339-1.332-7.032-1.817-9.641-.383-2.061-.637-3.446-.637-3.446l3.047-.2,4.052-.267,1.1-.073s.175,3.668.393,8.076c.3,5.989.928,20.85.928,20.85",
    transform: "translate(-1021.729 1067.676)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path258",
    d: "M1099.594-980.463l-2.3,11.553c-.641-3.339-1.332-7.032-1.817-9.641.7-1.07,1.591-2.429,2.41-3.646l4.052-.267c.445.823-2.34,2-2.34,2",
    transform: "translate(-1030.199 1066.709)",
    fill: "#e88134"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path260",
    d: "M992.572-1014.3l-11.283,31.224s-2.007.344-2.84-.242c0,0,.3-12.662,2.169-15.905,1.057-1.833,1.4-5.119,1.669-8.708.259-3.4.767-6.568.767-6.568l9.517.2",
    transform: "translate(-921.361 1096.507)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path262",
    d: "M1108.851-1278.942a2.988,2.988,0,0,1-2.077.086,4.291,4.291,0,0,1-1.335-.716,4.17,4.17,0,0,1-.521-.475s.028-.034.076-.1a6.028,6.028,0,0,0,.931-3.756,1.5,1.5,0,0,1,.516.135c.924.312,2.773,1.028,2.855,1.059h0s-.018.449-.015,1.256c0,.071,0,.146,0,.222,0,.1,0,.2,0,.3a6.635,6.635,0,0,1-.437,1.989",
    transform: "translate(-1038.983 1347.07)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path264",
    d: "M1122.775-1279.777c-2.933-.367-3.351-1.871-3.351-1.871a2.258,2.258,0,0,1,.508-.229c.924.313,2.773,1.028,2.855,1.059h0s-.018.232-.015,1.04",
    transform: "translate(-1052.475 1345.179)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path266",
    d: "M1171.767-1389.247s-.476-.887-1.015-.987-1.578-.082-1.616.143,1.4.844,1.494,1.09c.144.4.773.461.773.461l.364-.707",
    transform: "translate(-1098.71 1446.011)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path268",
    d: "M1112.277-1347.172a7.139,7.139,0,0,1-1.348.185c-1.095.046-2.509-.172-2.833-1.523-.547-2.272-1.385-3.682.912-4.375a3.532,3.532,0,0,1,2.488-.094,1.789,1.789,0,0,1,.838.874c.367.713.875,4.631-.057,4.933",
    transform: "translate(-1041.371 1411.475)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path270",
    d: "M1090.35-1376.3c-1.368.8-3.057-.269-3.631-.076s-.758,1.108-.8,1.4-.1.536-.83.291a.365.365,0,0,0-.273-.009c-.328.156-.014,1.085.088,1.289,0,0,.113.655-.3.931-.05.033-.83.291-2.38-2.644a2.581,2.581,0,0,1,.1-2.365c.526-.9,2.443-1.64,4.041-1.979a2.1,2.1,0,0,1,1.356.076,2.458,2.458,0,0,1,1.043,1.381,4.893,4.893,0,0,0,1.578,1.7",
    transform: "translate(-1017.661 1436.01)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path272",
    d: "M1166.588-1363.394c-5.755,4.452-3.948-4.88-3.948-4.88a12.581,12.581,0,0,1,2.735-.647c.635.059,1.265-1.668,3.554-4.427h0l-3.9-4.021s.3-1.06.526-.985a15.6,15.6,0,0,1,1.648.711c1.869.909,4.509,2.466,4.951,3.764,0,0-.506,6.57-5.569,10.486",
    transform: "translate(-1092.419 1434.912)",
    fill: "#9db0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path274",
    d: "M1176.661-1369.612l-.007-.011.007.011",
    transform: "translate(-1105.703 1426.788)",
    fill: "#7f2722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path276",
    d: "M989.815-1368.023a31.64,31.64,0,0,1-7.294.469,15.39,15.39,0,0,1-2.323-.469c-.772-.205-1.38-.4-1.38-.4-.657-.218-1.361-.7-1.19-1.459.518-2.3.891-8.417,1.4-12.211a2.059,2.059,0,0,0-.347-1.307h0a1.423,1.423,0,0,0-.251-.258,17.6,17.6,0,0,1-4.64-9.077c-.116-.584-.152-.939-.154-.96v0h0c.578-1.811,5.368-4.2,6.511-4.6a.109.109,0,0,1,.108.034h0a.4.4,0,0,1,.045.047c.018-.031.041-.067.066-.106.174-.273.5-.7.862-.776.537-.111,1.577-.114,1.618.112s-1.388.87-1.473,1.117c-.11.323-.539.434-.7.465l-.006,0,.024.075v.006l-3.821,4.1c2.343,2.715,3.006,4.429,3.639,4.357a12.325,12.325,0,0,1,2.737.592c.048-.005.1-.012.146-.017,0,0,2.034,1.41,3.712.663l.045.011c.383.1,3.113.817,3.717,1.586a10.127,10.127,0,0,1,.029,3.4c-.178,2.292-.509,4.886-.509,4.887-.071,2.508,1.291,9.039-.571,9.721",
    transform: "translate(-916.883 1454.268)",
    fill: "#9db0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path278",
    d: "M1069.418-1397.867c-.109.323-.539.434-.7.465a1.948,1.948,0,0,0-.417-.858.415.415,0,0,1,.045.047c.019-.031.041-.067.066-.106.174-.273.5-.7.862-.776.537-.111,1.577-.114,1.618.112s-1.388.87-1.473,1.117",
    transform: "translate(-1004.927 1454.268)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path280",
    d: "M1032.948-1158.289c-.772-.205-1.38-.4-1.38-.4-.658-.218-1.361-.7-1.19-1.459.518-2.3.891-8.417,1.4-12.211a2.059,2.059,0,0,0-.348-1.307c.68.724,2.524,2.854,2.824,5,.321,2.286-.6,8.111-1.308,10.379",
    transform: "translate(-969.634 1244.535)",
    fill: "#839de5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path282",
    d: "M995.641-1218.4a17.611,17.611,0,0,1-11.386,15.016l-.924,2.648,2.258.078s12.623-5.564,10.774-18.023l-.721.282",
    transform: "translate(-925.901 1286.4)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path284",
    d: "M1145.6-1238.415l-.526.123.1.771.894.711.722-.282-.143-1.07-.588-.315-.462.062",
    transform: "translate(-1076.333 1304.815)",
    fill: "#ed8232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path286",
    d: "M1098.19-1262.09s-.452.137-1.5,1.274a5.208,5.208,0,0,0,4.017,2.3,8.345,8.345,0,0,1-.108-1.858s-2.1-.391-2.411-1.713",
    transform: "translate(-1031.332 1326.777)",
    fill: "#839de5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path288",
    d: "M1152.589-1247.989s1.292.479,1.515,1.465a2.031,2.031,0,0,0,.162-1.281,3.87,3.87,0,0,0-.645-.966s.075.558-1.032.781",
    transform: "translate(-1083.321 1314.388)",
    fill: "#839de5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path290",
    d: "M2604.051-916.255a1.631,1.631,0,0,1-1.631-1.632,1.631,1.631,0,0,1,1.631-1.631,1.631,1.631,0,0,1,1.631,1.631,1.631,1.631,0,0,1-1.631,1.632",
    transform: "translate(-2431.745 1008.165)",
    fill: "#24386a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path292",
    d: "M2747.884-935.871a8.021,8.021,0,0,1-4.907-1.319c-2.125-1.706-1.8-5.444-1.5-9.059a23.212,23.212,0,0,0,.121-4.678,7.623,7.623,0,0,0-3.2-5.2l.47-.776a8.452,8.452,0,0,1,3.624,5.847,23.859,23.859,0,0,1-.116,4.881c-.277,3.22-.59,6.871,1.159,8.274,1.305,1.047,4.019,1.4,6.913.887a12.51,12.51,0,0,0,7.409-3.841c2.395-2.936,3.5-7.226,3.116-12.08a21.391,21.391,0,0,0-4.105-11.377l.7-.571a22.322,22.322,0,0,1,4.3,11.875c.4,5.088-.774,9.608-3.317,12.724a13.231,13.231,0,0,1-7.954,4.161,15.823,15.823,0,0,1-2.73.246",
    transform: "translate(-2558.22 1050.352)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path294",
    d: "M2652.806-926.419c0,.066,0,.132-.009.2a2.142,2.142,0,0,1-.542,1.242c-.012.015-.026.028-.04.042a2.057,2.057,0,0,1-.5.393,2.042,2.042,0,0,1-.541.217,1.583,1.583,0,0,1-.21.04l-.109.014c-.065.006-.132.009-.2.009a2.013,2.013,0,0,1-.272-.019c-.018,0-.035,0-.051-.006h0a2.153,2.153,0,0,1-1.83-2.128,2.1,2.1,0,0,1,.04-.41,2.108,2.108,0,0,1,.246-.659,2.149,2.149,0,0,1,1.867-1.083,2.149,2.149,0,0,1,1.889,1.119,2.142,2.142,0,0,1,.265,1.033",
    transform: "translate(-2474.602 1016.585)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path296",
    d: "M2650.655-912.622l-.021.062h0l-.006.017,0,.01-.2.574-.028-.01-.006,0-.395-.136-.361-.126-.051-.017-.3-.1-.051-.017-.178-.062a2.12,2.12,0,0,1,.246-.659l.167.058.05.019.3.1.051.017.373.13.412.144",
    transform: "translate(-2475.122 1002.188)",
    fill: "#c0d8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path298",
    d: "M2689.934-862.642l-.533-1.454a.491.491,0,0,0-.393-.318l-.681-.1.036-.249.68.1a.738.738,0,0,1,.594.479l.533,1.454-.236.087",
    transform: "translate(-2511.643 957.235)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path300",
    d: "M2685.117-874.685l-1.571,1.05a.412.412,0,0,1-.562-.1l-1.4-1.932a1.187,1.187,0,0,1,.278-1.5l.742-.138-.294.488a.975.975,0,0,0,.037,1.059l.889,1.277a.318.318,0,0,0,.451.073l1.051-.785.384.508",
    transform: "translate(-2505.223 968.904)",
    fill: "#9db0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path302",
    d: "M2726.835-843.181a.128.128,0,0,1,.178-.029.128.128,0,0,1,.029.178.128.128,0,0,1-.178.029.128.128,0,0,1-.029-.178",
    transform: "translate(-2547.435 937.216)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path304",
    d: "M2672.622-911.836l-.935.667-1.678-2.182a1.1,1.1,0,0,0-.291-.261l-.034-.021h0a1.087,1.087,0,0,0-.329-.121.517.517,0,0,0-.349.058l-1.167.829-.267-.221a.321.321,0,0,1-.116-.256l.036-1.273-.389-.161a.187.187,0,0,1-.1-.245l.367-.887a.238.238,0,0,1,.282-.14l.082.021a1.163,1.163,0,0,0,.136.026,1.04,1.04,0,0,0,.97-.422.255.255,0,0,1,.311-.086l1.466.642a1.6,1.6,0,0,1,.915.717l.72.93a.7.7,0,0,1,.1.684l-.258.654.579.75a.209.209,0,0,1-.044.3",
    transform: "translate(-2491.794 1005.388)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path306",
    d: "M2682.006-912.9l0,.011.009.011-1.456-1.724a1.279,1.279,0,0,0-.473-.349l-2.435-1.082a1.164,1.164,0,0,0,.136.026,1.04,1.04,0,0,0,.97-.422.255.255,0,0,1,.311-.086l1.466.642a1.6,1.6,0,0,1,.915.717l.72.93a.7.7,0,0,1,.1.684l-.255.643",
    transform: "translate(-2501.709 1005.388)",
    fill: "#e88134"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path308",
    d: "M2662.54-909.224l.418.146-.309.765-.389-.164.28-.747",
    transform: "translate(-2487.399 998.592)",
    fill: "#86a9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path310",
    d: "M2656.5-910.106l-.051-.018.249-.7.051.019-.249.7",
    transform: "translate(-2481.992 1000.08)",
    fill: "#86a9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path312",
    d: "M2651.55-911.811l-.05-.019.249-.7.05.019-.249.7",
    transform: "translate(-2477.392 1001.667)",
    fill: "#86a9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path314",
    d: "M2675.925-888.161a1.081,1.081,0,0,0-.329-.121.516.516,0,0,0-.349.058l-1.058.928a.138.138,0,0,1-.2-.021l-.2-.274a.451.451,0,0,1-.088-.279l.036-1.275a15.286,15.286,0,0,1,2.192.984",
    transform: "translate(-2498.036 979.916)",
    fill: "#e88134"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path316",
    d: "M3332.082-562.139v.914a.314.314,0,0,1-.073.2.417.417,0,0,1-.2.131.414.414,0,0,1-.076.018.477.477,0,0,1-.074.006h-17.344a.4.4,0,0,1-.419-.334v-.95a.4.4,0,0,1,.419-.335h17.344a.484.484,0,0,1,.074.006.416.416,0,0,1,.076.019.416.416,0,0,1,.2.132.31.31,0,0,1,.073.2",
    transform: "translate(-3093.459 676.111)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path318",
    d: "M3323.565-560.873h-9.291a.367.367,0,0,1-.375-.334v-.95a.368.368,0,0,1,.375-.335h8.151a2.834,2.834,0,0,0,1.141,1.619",
    transform: "translate(-3093.459 676.111)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path320",
    d: "M3541.069-560.873h-.2v-1.619h.2v1.619",
    transform: "translate(-3304.556 676.111)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path322",
    d: "M3531.535-560.873h-.2v-1.619h.2v1.619",
    transform: "translate(-3295.69 676.111)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path324",
    d: "M3520.1-560.873h-.2v-1.619h.2v1.619",
    transform: "translate(-3285.05 676.111)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path326",
    d: "M3502.562-560.873h-.2v-1.619h.2v1.619",
    transform: "translate(-3268.743 676.111)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path328",
    d: "M3484.015-560.873h-.2v-1.619h.2v1.619",
    transform: "translate(-3251.494 676.111)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path330",
    d: "M3455.589-560.873h-.2v-1.619h.2v1.619",
    transform: "translate(-3225.056 676.111)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path332",
    d: "M3428.963-560.873h-.2v-1.619h.2v1.619",
    transform: "translate(-3200.291 676.111)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path334",
    d: "M3405.2-560.873h-.2v-1.619h.2v1.619",
    transform: "translate(-3178.193 676.111)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path336",
    d: "M3550.149-560.873h-.2v-1.619h.2v1.619",
    transform: "translate(-3313.001 676.111)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path338",
    d: "M3556.149-560.873h-.2v-1.619h.2v1.619",
    transform: "translate(-3318.582 676.111)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path340",
    d: "M3561.949-560.873h-.2v-1.619h.2v1.619",
    transform: "translate(-3323.977 676.111)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path342",
    d: "M3566.3-562.486v1.608a.47.47,0,0,1-.074.006h-.124v-1.619h.124a.47.47,0,0,1,.074.006",
    transform: "translate(-3328.018 676.111)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path344",
    d: "M3570.215-562.014v1.308a.418.418,0,0,1-.2.131v-1.571a.417.417,0,0,1,.2.131",
    transform: "translate(-3331.665 675.789)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path346",
    d: "M3305.562-585.286v.914a.31.31,0,0,1-.072.2.416.416,0,0,1-.2.132.511.511,0,0,1-.076.018.482.482,0,0,1-.075.006H3287.8a.4.4,0,0,1-.419-.334v-.951a.4.4,0,0,1,.419-.334h17.392l.016,0,.011,0a.527.527,0,0,1,.076.018l.011,0,.01,0,.021.008.012.006.01.006.02.01.021.013.016.011h0l.01.008a.262.262,0,0,1,.031.026l.009.007.007.009.016.018a.31.31,0,0,1,.072.2",
    transform: "translate(-3068.794 697.639)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path348",
    d: "M3297.046-584.02h-9.292a.366.366,0,0,1-.374-.334v-.951a.367.367,0,0,1,.374-.334h8.151l.011.04a2.834,2.834,0,0,0,1.13,1.579",
    transform: "translate(-3068.794 697.639)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path350",
    d: "M3514.562-584.02h-.2v-1.619h.2v1.619",
    transform: "translate(-3279.904 697.639)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path352",
    d: "M3505.016-584.02h-.2v-1.619h.2v1.619",
    transform: "translate(-3271.025 697.639)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path354",
    d: "M3493.576-584.02h-.2v-1.619h.2v1.619",
    transform: "translate(-3260.385 697.639)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path356",
    d: "M3476.042-584.02h-.2v-1.619h.2v1.619",
    transform: "translate(-3244.078 697.639)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path358",
    d: "M3457.5-584.02h-.2v-1.619h.2v1.619",
    transform: "translate(-3226.829 697.639)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path360",
    d: "M3429.07-584.02h-.2v-1.619h.2v1.619",
    transform: "translate(-3200.391 697.639)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path362",
    d: "M3402.455-584.02h-.2v-1.619h.2v1.619",
    transform: "translate(-3175.638 697.639)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path364",
    d: "M3378.7-584.02h-.2v-1.619h.2v1.619",
    transform: "translate(-3153.541 697.639)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path366",
    d: "M3523.642-584.02h-.2v-1.619h.2v1.619",
    transform: "translate(-3288.349 697.639)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path368",
    d: "M3529.642-584.02h-.2v-1.619h.2v1.619",
    transform: "translate(-3293.929 697.639)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path370",
    d: "M3535.429-584.02h-.2v-1.619h.2v1.619",
    transform: "translate(-3299.311 697.639)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path372",
    d: "M3539.788-585.633v1.608a.468.468,0,0,1-.074.006h-.123v-1.619h.123a.468.468,0,0,1,.074.006",
    transform: "translate(-3303.366 697.639)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    d: "M3543.708-585.173v1.307a.416.416,0,0,1-.2.132v-1.572a.415.415,0,0,1,.2.132",
    transform: "translate(-3307.013 697.329)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path376",
    d: "M3318.376-607.86v.915a.309.309,0,0,1-.072.2.419.419,0,0,1-.2.131.419.419,0,0,1-.077.019.467.467,0,0,1-.074.006h-17.344a.488.488,0,0,1-.193-.04.36.36,0,0,1-.225-.279v-.966a.4.4,0,0,1,.418-.334h17.344a.467.467,0,0,1,.074.006.417.417,0,0,1,.077.018.42.42,0,0,1,.2.131.311.311,0,0,1,.072.2",
    transform: "translate(-3080.711 718.633)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path378",
    d: "M3309.86-606.593h-9.292a.4.4,0,0,1-.173-.04.356.356,0,0,1-.2-.279v-.966a.365.365,0,0,1,.374-.334h8.151a2.845,2.845,0,0,0,1.083,1.579l.058.04",
    transform: "translate(-3080.711 718.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path380",
    d: "M3527.375-606.593h-.2v-1.619h.2v1.619",
    transform: "translate(-3291.821 718.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path382",
    d: "M3517.829-606.593h-.2v-1.619h.2v1.619",
    transform: "translate(-3282.942 718.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path384",
    d: "M3506.39-606.593h-.2v-1.619h.2v1.619",
    transform: "translate(-3272.302 718.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path386",
    d: "M3488.855-606.593h-.2v-1.619h.2v1.619",
    transform: "translate(-3255.995 718.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path388",
    d: "M3470.309-606.593h-.2v-1.619h.2v1.619",
    transform: "translate(-3238.746 718.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path390",
    d: "M3441.883-606.593h-.2v-1.619h.2v1.619",
    transform: "translate(-3212.308 718.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path392",
    d: "M3415.268-606.593h-.2v-1.619h.2v1.619",
    transform: "translate(-3187.556 718.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path394",
    d: "M3391.508-606.593h-.2v-1.619h.2v1.619",
    transform: "translate(-3165.457 718.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path396",
    d: "M3536.455-606.593h-.2v-1.619h.2v1.619",
    transform: "translate(-3300.265 718.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path398",
    d: "M3542.455-606.593h-.2v-1.619h.2v1.619",
    transform: "translate(-3305.846 718.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path400",
    d: "M3548.242-606.593h-.2v-1.619h.2v1.619",
    transform: "translate(-3311.228 718.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path402",
    d: "M3552.6-608.206v1.608a.473.473,0,0,1-.074.006h-.123v-1.619h.123a.465.465,0,0,1,.074.006",
    transform: "translate(-3315.283 718.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path404",
    d: "M3556.521-607.747v1.308a.418.418,0,0,1-.2.132v-1.571a.418.418,0,0,1,.2.132",
    transform: "translate(-3318.929 718.323)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path406",
    d: "M3324.322-631.019v.915a.313.313,0,0,1-.072.2.417.417,0,0,1-.2.132.525.525,0,0,1-.077.019.48.48,0,0,1-.074.006h-17.343a.4.4,0,0,1-.42-.335v-.95a.388.388,0,0,1,.37-.332l.05,0H3323.9a.627.627,0,0,1,.074.006.517.517,0,0,1,.077.019.417.417,0,0,1,.2.132.312.312,0,0,1,.072.2",
    transform: "translate(-3086.242 740.173)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path408",
    d: "M3315.805-629.752h-9.292a.368.368,0,0,1-.375-.335v-.95a.365.365,0,0,1,.33-.332.341.341,0,0,1,.045,0h8.151v0a2.842,2.842,0,0,0,1.141,1.617",
    transform: "translate(-3086.242 740.173)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path410",
    d: "M3533.31-629.752h-.2v-1.62h.2v1.62",
    transform: "translate(-3297.34 740.173)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path412",
    d: "M3523.775-629.752h-.2v-1.62h.2v1.62",
    transform: "translate(-3288.473 740.173)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path414",
    d: "M3512.335-629.752h-.2v-1.62h.2v1.62",
    transform: "translate(-3277.833 740.173)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path416",
    d: "M3494.8-629.752h-.2v-1.62h.2v1.62",
    transform: "translate(-3261.526 740.173)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path418",
    d: "M3476.255-629.752h-.2v-1.62h.2v1.62",
    transform: "translate(-3244.276 740.173)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path420",
    d: "M3447.829-629.752h-.2v-1.62h.2v1.62",
    transform: "translate(-3217.838 740.173)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path422",
    d: "M3421.2-629.752h-.2v-1.62h.2v1.62",
    transform: "translate(-3193.074 740.173)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path424",
    d: "M3397.442-629.752h-.2v-1.62h.2v1.62",
    transform: "translate(-3170.976 740.173)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path426",
    d: "M3542.389-629.752h-.2v-1.62h.2v1.62",
    transform: "translate(-3305.784 740.173)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path428",
    d: "M3548.388-629.752h-.2v-1.62h.2v1.62",
    transform: "translate(-3311.365 740.173)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path430",
    d: "M3554.188-629.752h-.2v-1.62h.2v1.62",
    transform: "translate(-3316.759 740.173)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path432",
    d: "M3558.536-631.366v1.608a.49.49,0,0,1-.074.006h-.124v-1.619h.124a.482.482,0,0,1,.074.006",
    transform: "translate(-3320.802 740.173)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path434",
    d: "M3562.455-630.894v1.308a.419.419,0,0,1-.2.131v-1.571a.418.418,0,0,1,.2.131",
    transform: "translate(-3324.447 739.851)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path436",
    d: "M3306.095-654.126v.914a.308.308,0,0,1-.072.2.417.417,0,0,1-.2.133.516.516,0,0,1-.076.018l-.025,0-.013,0h-17.38a.4.4,0,0,1-.419-.334v-.966a.379.379,0,0,1,.315-.308l.012,0a.5.5,0,0,1,.091-.008h17.382l.016,0h0l.02,0a.5.5,0,0,1,.076.018.417.417,0,0,1,.2.132.308.308,0,0,1,.072.2",
    transform: "translate(-3069.29 761.663)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path438",
    d: "M3297.578-652.859h-9.292a.366.366,0,0,1-.374-.334v-.966a.364.364,0,0,1,.291-.31l.016,0a.381.381,0,0,1,.066-.006h8.151l0,.011a2.834,2.834,0,0,0,1.134,1.6l0,0",
    transform: "translate(-3069.29 761.664)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path440",
    d: "M3515.082-652.859h-.2v-1.619h.2v1.619",
    transform: "translate(-3280.387 761.664)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path442",
    d: "M3505.536-652.859h-.2v-1.619h.2v1.619",
    transform: "translate(-3271.509 761.664)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path444",
    d: "M3494.1-652.859h-.2v-1.619h.2v1.619",
    transform: "translate(-3260.869 761.664)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path446",
    d: "M3476.562-652.859h-.2v-1.619h.2v1.619",
    transform: "translate(-3244.562 761.664)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path448",
    d: "M3458.016-652.859h-.2v-1.619h.2v1.619",
    transform: "translate(-3227.313 761.664)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path450",
    d: "M3429.589-652.859h-.2v-1.619h.2v1.619",
    transform: "translate(-3200.874 761.664)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path452",
    d: "M3402.976-652.859h-.2v-1.619h.2v1.619",
    transform: "translate(-3176.122 761.664)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path454",
    d: "M3379.215-652.859h-.2v-1.619h.2v1.619",
    transform: "translate(-3154.024 761.664)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path456",
    d: "M3524.162-652.859h-.2v-1.619h.2v1.619",
    transform: "translate(-3288.832 761.664)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path458",
    d: "M3530.162-652.859h-.2v-1.619h.2v1.619",
    transform: "translate(-3294.413 761.664)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path460",
    d: "M3535.949-652.859h-.2v-1.619h.2v1.619",
    transform: "translate(-3299.795 761.664)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path462",
    d: "M3540.309-654.473v1.608a.487.487,0,0,1-.075.006h-.123v-1.619h.123a.5.5,0,0,1,.075.006",
    transform: "translate(-3303.849 761.664)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path464",
    d: "M3544.228-654.013v1.307a.415.415,0,0,1-.2.132v-1.572a.415.415,0,0,1,.2.132",
    transform: "translate(-3307.495 761.353)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path466",
    d: "M3305.562-677.112v.914a.31.31,0,0,1-.072.2.415.415,0,0,1-.2.132.425.425,0,0,1-.06.015h0l-.016,0a.505.505,0,0,1-.075.006H3287.8l-.054,0-.021,0a.382.382,0,0,1-.344-.328v-.951a.4.4,0,0,1,.419-.334h17.392l.016,0,.011,0a.416.416,0,0,1,.076.019l.011,0,.01,0,.021.008.022.011.02.01.021.013.016.011h0l.01.009a.267.267,0,0,1,.031.026l.009.008.007.008.016.018a.31.31,0,0,1,.072.2",
    transform: "translate(-3068.794 783.042)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path468",
    d: "M3297.046-675.846h-9.314l-.024,0a.363.363,0,0,1-.328-.331v-.951a.367.367,0,0,1,.374-.334h8.151l.011.04a2.832,2.832,0,0,0,1.114,1.568l.016.011",
    transform: "translate(-3068.795 783.042)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path470",
    d: "M3514.562-675.846h-.2v-1.619h.2v1.619",
    transform: "translate(-3279.904 783.042)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path472",
    d: "M3505.016-675.846h-.2v-1.619h.2v1.619",
    transform: "translate(-3271.025 783.042)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path474",
    d: "M3493.576-675.846h-.2v-1.619h.2v1.619",
    transform: "translate(-3260.385 783.042)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path476",
    d: "M3476.042-675.846h-.2v-1.619h.2v1.619",
    transform: "translate(-3244.078 783.042)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path478",
    d: "M3457.5-675.846h-.2v-1.619h.2v1.619",
    transform: "translate(-3226.829 783.042)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path480",
    d: "M3429.07-675.846h-.2v-1.619h.2v1.619",
    transform: "translate(-3200.391 783.042)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path482",
    d: "M3402.455-675.846h-.2v-1.619h.2v1.619",
    transform: "translate(-3175.638 783.042)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path484",
    d: "M3378.7-675.846h-.2v-1.619h.2v1.619",
    transform: "translate(-3153.541 783.042)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path486",
    d: "M3523.642-675.846h-.2v-1.619h.2v1.619",
    transform: "translate(-3288.349 783.042)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path488",
    d: "M3529.642-675.846h-.2v-1.619h.2v1.619",
    transform: "translate(-3293.929 783.042)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path490",
    d: "M3535.429-675.846h-.2v-1.619h.2v1.619",
    transform: "translate(-3299.311 783.042)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path492",
    d: "M3539.788-677.459v1.608a.468.468,0,0,1-.074.006h-.123v-1.619h.123a.475.475,0,0,1,.074.006",
    transform: "translate(-3303.366 783.042)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path494",
    d: "M3543.708-676.987v1.307a.415.415,0,0,1-.2.132v-1.571a.414.414,0,0,1,.2.131",
    transform: "translate(-3307.013 782.72)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path496",
    d: "M3318.376-699.686v.914a.309.309,0,0,1-.072.2.42.42,0,0,1-.2.131.429.429,0,0,1-.077.019.482.482,0,0,1-.074.006h-17.344a.487.487,0,0,1-.193-.04.36.36,0,0,1-.225-.279v-.966a.4.4,0,0,1,.418-.334h17.344a.467.467,0,0,1,.074.006.422.422,0,0,1,.077.018.421.421,0,0,1,.2.131.311.311,0,0,1,.072.2",
    transform: "translate(-3080.711 804.037)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path498",
    d: "M3309.86-698.419h-9.292a.4.4,0,0,1-.173-.04.356.356,0,0,1-.2-.279v-.966a.365.365,0,0,1,.374-.334h8.151a2.844,2.844,0,0,0,1.083,1.579l.058.04",
    transform: "translate(-3080.711 804.037)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path500",
    d: "M3527.375-698.419h-.2v-1.619h.2v1.619",
    transform: "translate(-3291.821 804.037)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path502",
    d: "M3517.829-698.419h-.2v-1.619h.2v1.619",
    transform: "translate(-3282.942 804.037)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path504",
    d: "M3506.39-698.419h-.2v-1.619h.2v1.619",
    transform: "translate(-3272.302 804.037)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path506",
    d: "M3488.855-698.419h-.2v-1.619h.2v1.619",
    transform: "translate(-3255.995 804.037)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path508",
    d: "M3470.309-698.419h-.2v-1.619h.2v1.619",
    transform: "translate(-3238.746 804.037)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path510",
    d: "M3441.883-698.419h-.2v-1.619h.2v1.619",
    transform: "translate(-3212.308 804.037)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path512",
    d: "M3415.268-698.419h-.2v-1.619h.2v1.619",
    transform: "translate(-3187.556 804.037)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path514",
    d: "M3391.508-698.419h-.2v-1.619h.2v1.619",
    transform: "translate(-3165.457 804.037)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path516",
    d: "M3536.455-698.419h-.2v-1.619h.2v1.619",
    transform: "translate(-3300.265 804.037)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path518",
    d: "M3542.455-698.419h-.2v-1.619h.2v1.619",
    transform: "translate(-3305.846 804.037)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path520",
    d: "M3548.242-698.419h-.2v-1.619h.2v1.619",
    transform: "translate(-3311.228 804.037)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path522",
    d: "M3552.6-700.033v1.608a.465.465,0,0,1-.074.006h-.123v-1.619h.123a.48.48,0,0,1,.074.006",
    transform: "translate(-3315.283 804.037)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path524",
    d: "M3556.521-699.573v1.307a.419.419,0,0,1-.2.132v-1.571a.414.414,0,0,1,.2.133",
    transform: "translate(-3318.929 803.727)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path526",
    d: "M3338.642-722.846v.915a.319.319,0,0,1-.072.2.427.427,0,0,1-.2.132.522.522,0,0,1-.078.019.469.469,0,0,1-.073.006h-17.344a.4.4,0,0,1-.419-.335v-.95a.387.387,0,0,1,.369-.332l.05,0h17.344a.484.484,0,0,1,.073.006.432.432,0,0,1,.078.018.426.426,0,0,1,.2.132.319.319,0,0,1,.072.2",
    transform: "translate(-3099.56 825.577)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path528",
    d: "M3330.125-721.578h-9.292a.367.367,0,0,1-.374-.335v-.95a.363.363,0,0,1,.329-.332l.045,0h8.151v0a2.844,2.844,0,0,0,1.14,1.617",
    transform: "translate(-3099.56 825.577)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path530",
    d: "M3547.629-721.578h-.2v-1.62h.2v1.62",
    transform: "translate(-3310.658 825.577)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path532",
    d: "M3538.095-721.578h-.2v-1.62h.2v1.62",
    transform: "translate(-3301.791 825.577)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path534",
    d: "M3526.655-721.578h-.2v-1.62h.2v1.62",
    transform: "translate(-3291.152 825.577)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path536",
    d: "M3509.122-721.578h-.2v-1.62h.2v1.62",
    transform: "translate(-3274.844 825.577)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path538",
    d: "M3490.576-721.578h-.2v-1.62h.2v1.62",
    transform: "translate(-3257.595 825.577)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path540",
    d: "M3462.148-721.578h-.2v-1.62h.2v1.62",
    transform: "translate(-3231.156 825.577)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path542",
    d: "M3435.535-721.578h-.2v-1.62h.2v1.62",
    transform: "translate(-3206.404 825.577)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path544",
    d: "M3411.763-721.578h-.2v-1.62h.2v1.62",
    transform: "translate(-3184.294 825.577)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path546",
    d: "M3556.722-721.578h-.2v-1.62h.2v1.62",
    transform: "translate(-3319.115 825.577)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path548",
    d: "M3562.71-721.578h-.2v-1.62h.2v1.62",
    transform: "translate(-3324.683 825.577)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path550",
    d: "M3568.508-721.578h-.2v-1.62h.2v1.62",
    transform: "translate(-3330.076 825.577)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path552",
    d: "M3572.868-723.193v1.609a.466.466,0,0,1-.073.006h-.124v-1.62h.124a.622.622,0,0,1,.073.006",
    transform: "translate(-3334.132 825.577)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path554",
    d: "M3576.788-722.72v1.308a.422.422,0,0,1-.2.132v-1.571a.42.42,0,0,1,.2.132",
    transform: "translate(-3337.778 825.254)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path556",
    d: "M3306.1-745.952v.914a.309.309,0,0,1-.072.2.414.414,0,0,1-.2.132.491.491,0,0,1-.076.018l-.025,0-.019,0h-17.374a.4.4,0,0,1-.42-.334v-.951a.4.4,0,0,1,.42-.334H3305.7a.31.31,0,0,1,.052,0,.491.491,0,0,1,.076.018l.036.014.021.009,0,0,.021.011,0,0,.019.011a.386.386,0,0,1,.042.031l.011.01,0,0,.007.007,0,0,.012.012.017.02a.309.309,0,0,1,.072.2",
    transform: "translate(-3069.291 847.067)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path558",
    d: "M3297.578-744.686h-9.292a.366.366,0,0,1-.374-.334v-.951a.367.367,0,0,1,.374-.334h8.151l.011.037a2.83,2.83,0,0,0,1.127,1.579l0,0",
    transform: "translate(-3069.29 847.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path560",
    d: "M3515.082-744.686h-.2V-746.3h.2v1.619",
    transform: "translate(-3280.387 847.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path562",
    d: "M3505.536-744.686h-.2V-746.3h.2v1.619",
    transform: "translate(-3271.509 847.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path564",
    d: "M3494.1-744.686h-.2V-746.3h.2v1.619",
    transform: "translate(-3260.869 847.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path566",
    d: "M3476.562-744.686h-.2V-746.3h.2v1.619",
    transform: "translate(-3244.562 847.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path568",
    d: "M3458.016-744.686h-.2V-746.3h.2v1.619",
    transform: "translate(-3227.313 847.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path570",
    d: "M3429.589-744.686h-.2V-746.3h.2v1.619",
    transform: "translate(-3200.874 847.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path572",
    d: "M3402.976-744.686h-.2V-746.3h.2v1.619",
    transform: "translate(-3176.122 847.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path574",
    d: "M3379.215-744.686h-.2V-746.3h.2v1.619",
    transform: "translate(-3154.024 847.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path576",
    d: "M3524.162-744.686h-.2V-746.3h.2v1.619",
    transform: "translate(-3288.832 847.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path578",
    d: "M3530.162-744.686h-.2V-746.3h.2v1.619",
    transform: "translate(-3294.413 847.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path580",
    d: "M3535.949-744.686h-.2V-746.3h.2v1.619",
    transform: "translate(-3299.795 847.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path582",
    d: "M3540.309-746.3v1.608a.5.5,0,0,1-.075.006h-.123V-746.3h.123a.487.487,0,0,1,.075.006",
    transform: "translate(-3303.849 847.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path584",
    d: "M3544.228-745.839v1.307a.415.415,0,0,1-.2.132v-1.572a.414.414,0,0,1,.2.132",
    transform: "translate(-3307.495 846.757)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path586",
    d: "M3324.322-768.566v.914a.31.31,0,0,1-.072.2.412.412,0,0,1-.2.132.5.5,0,0,1-.077.018.48.48,0,0,1-.074.006h-17.343a.474.474,0,0,1-.187-.037.359.359,0,0,1-.23-.283l0-.014v-.951a.386.386,0,0,1,.37-.331.416.416,0,0,1,.049,0H3323.9a.493.493,0,0,1,.075.006.5.5,0,0,1,.076.018.411.411,0,0,1,.2.132.31.31,0,0,1,.072.2",
    transform: "translate(-3086.242 868.099)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path588",
    d: "M3315.805-767.3h-9.292a.388.388,0,0,1-.168-.037.355.355,0,0,1-.205-.283l0-.014v-.951a.363.363,0,0,1,.33-.331.341.341,0,0,1,.045,0h8.151v0a2.846,2.846,0,0,0,1.087,1.579l.053.037",
    transform: "translate(-3086.242 868.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path590",
    d: "M3533.31-767.3h-.2v-1.619h.2v1.619",
    transform: "translate(-3297.34 868.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path592",
    d: "M3523.775-767.3h-.2v-1.619h.2v1.619",
    transform: "translate(-3288.473 868.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path594",
    d: "M3512.335-767.3h-.2v-1.619h.2v1.619",
    transform: "translate(-3277.833 868.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path596",
    d: "M3494.8-767.3h-.2v-1.619h.2v1.619",
    transform: "translate(-3261.526 868.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path598",
    d: "M3476.255-767.3h-.2v-1.619h.2v1.619",
    transform: "translate(-3244.276 868.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path600",
    d: "M3447.829-767.3h-.2v-1.619h.2v1.619",
    transform: "translate(-3217.838 868.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path602",
    d: "M3421.2-767.3h-.2v-1.619h.2v1.619",
    transform: "translate(-3193.074 868.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path604",
    d: "M3397.442-767.3h-.2v-1.619h.2v1.619",
    transform: "translate(-3170.976 868.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path606",
    d: "M3542.389-767.3h-.2v-1.619h.2v1.619",
    transform: "translate(-3305.784 868.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path608",
    d: "M3548.388-767.3h-.2v-1.619h.2v1.619",
    transform: "translate(-3311.365 868.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path610",
    d: "M3554.188-767.3h-.2v-1.619h.2v1.619",
    transform: "translate(-3316.759 868.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path612",
    d: "M3558.536-768.913v1.608a.482.482,0,0,1-.074.006h-.124v-1.619h.124a.482.482,0,0,1,.074.006",
    transform: "translate(-3320.802 868.099)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path614",
    d: "M3562.455-768.452v1.307a.42.42,0,0,1-.2.132v-1.572a.413.413,0,0,1,.2.132",
    transform: "translate(-3324.447 867.789)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path616",
    d: "M3332.082-791.686v.915a.313.313,0,0,1-.073.2.415.415,0,0,1-.2.131.514.514,0,0,1-.076.019l-.024,0h-17.394a.4.4,0,0,1-.419-.335v-.95a.4.4,0,0,1,.419-.335h17.344a.492.492,0,0,1,.074.006.5.5,0,0,1,.076.019.415.415,0,0,1,.2.131.312.312,0,0,1,.073.2",
    transform: "translate(-3093.459 889.602)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path618",
    d: "M3323.565-790.418h-9.291a.368.368,0,0,1-.375-.335v-.95a.368.368,0,0,1,.375-.335h8.151a2.837,2.837,0,0,0,1.137,1.617l0,0",
    transform: "translate(-3093.459 889.602)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path620",
    d: "M3541.069-790.418h-.2v-1.62h.2v1.62",
    transform: "translate(-3304.556 889.602)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path622",
    d: "M3531.535-790.418h-.2v-1.62h.2v1.62",
    transform: "translate(-3295.69 889.602)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path624",
    d: "M3520.1-790.418h-.2v-1.62h.2v1.62",
    transform: "translate(-3285.05 889.602)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path626",
    d: "M3502.562-790.418h-.2v-1.62h.2v1.62",
    transform: "translate(-3268.743 889.602)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path628",
    d: "M3484.015-790.418h-.2v-1.62h.2v1.62",
    transform: "translate(-3251.494 889.602)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path630",
    d: "M3455.589-790.418h-.2v-1.62h.2v1.62",
    transform: "translate(-3225.056 889.602)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path632",
    d: "M3428.976-790.418h-.2v-1.62h.2v1.62",
    transform: "translate(-3200.304 889.602)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path634",
    d: "M3405.2-792.038v1.62h-.2v-1.62h.2",
    transform: "translate(-3178.193 889.602)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path636",
    d: "M3550.149-790.418h-.2v-1.62h.2v1.62",
    transform: "translate(-3313.001 889.602)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path638",
    d: "M3556.149-790.418h-.2v-1.62h.2v1.62",
    transform: "translate(-3318.582 889.602)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path640",
    d: "M3561.949-790.418h-.2v-1.62h.2v1.62",
    transform: "translate(-3323.977 889.602)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path642",
    d: "M3566.3-792.033v1.608a.47.47,0,0,1-.074.006h-.124v-1.619h.124a.477.477,0,0,1,.074.006",
    transform: "translate(-3328.018 889.602)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path644",
    d: "M3570.215-791.56v1.308a.416.416,0,0,1-.2.132v-1.571a.418.418,0,0,1,.2.131",
    transform: "translate(-3331.665 889.279)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path646",
    d: "M3181.672-766.742a8.243,8.243,0,0,1,8.243-8.243,8.243,8.243,0,0,1,8.243,8.243,8.243,8.243,0,0,1-8.243,8.243,8.243,8.243,0,0,1-8.243-8.243",
    transform: "translate(-2970.481 873.741)",
    fill: "#e2810e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path648",
    d: "M3171.393-766.742a8.242,8.242,0,0,1,8.242-8.243,8.243,8.243,0,0,1,8.244,8.243,8.244,8.244,0,0,1-8.244,8.243,8.243,8.243,0,0,1-8.242-8.243",
    transform: "translate(-2960.921 873.741)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path650",
    d: "M3189.369-762.669a7.07,7.07,0,0,0-7.062,7.062,7.07,7.07,0,0,0,7.062,7.063,7.07,7.07,0,0,0,7.063-7.062A7.07,7.07,0,0,0,3189.369-762.669Zm0,14.572a7.46,7.46,0,0,1-5.31-2.2,7.461,7.461,0,0,1-2.2-5.311,7.461,7.461,0,0,1,2.2-5.31,7.461,7.461,0,0,1,5.31-2.2,7.461,7.461,0,0,1,5.311,2.2,7.46,7.46,0,0,1,2.2,5.31,7.46,7.46,0,0,1-2.2,5.311,7.46,7.46,0,0,1-5.311,2.2",
    transform: "translate(-2970.655 862.705)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path652",
    d: "M3246.536-727.312a1.233,1.233,0,0,0-.017-.436.9.9,0,0,0-.185-.362,1.688,1.688,0,0,0-.368-.325,4.441,4.441,0,0,0-.572-.32,11.8,11.8,0,0,1-1.055-.58,3.78,3.78,0,0,1-.789-.642,2.211,2.211,0,0,1-.466-.783,2.265,2.265,0,0,1-.08-1,2.263,2.263,0,0,1,.281-.876,2.081,2.081,0,0,1,.582-.646,2.6,2.6,0,0,1,.834-.4,3.454,3.454,0,0,1,1.04-.119l.147-1.238,1,.118-.149,1.255a3.1,3.1,0,0,1,.938.4,2.422,2.422,0,0,1,.675.643,2.408,2.408,0,0,1,.374.863,3.1,3.1,0,0,1,.041,1.064l-1.8-.214a1.524,1.524,0,0,0-.186-1.075,1.061,1.061,0,0,0-.783-.442,1.338,1.338,0,0,0-.492.021.9.9,0,0,0-.358.174.844.844,0,0,0-.231.3,1.224,1.224,0,0,0-.11.392,1.158,1.158,0,0,0,.017.4.844.844,0,0,0,.177.346,1.731,1.731,0,0,0,.372.326,5.818,5.818,0,0,0,.594.343c.385.2.733.4,1.044.593a3.761,3.761,0,0,1,.785.647,2.228,2.228,0,0,1,.466.785,2.257,2.257,0,0,1,.08,1,2.283,2.283,0,0,1-.285.893,2.065,2.065,0,0,1-.585.64,2.52,2.52,0,0,1-.837.382,3.775,3.775,0,0,1-1.045.11l-.137,1.151-.99-.117.136-1.146a4.2,4.2,0,0,1-.973-.344,2.673,2.673,0,0,1-.8-.6,2.37,2.37,0,0,1-.5-.9,2.9,2.9,0,0,1-.083-1.218l1.8.214a1.789,1.789,0,0,0,.033.7,1.151,1.151,0,0,0,.256.477,1.118,1.118,0,0,0,.412.284,1.95,1.95,0,0,0,.493.126,1.6,1.6,0,0,0,.522-.014,1.075,1.075,0,0,0,.4-.164.847.847,0,0,0,.261-.289,1.022,1.022,0,0,0,.122-.387",
    transform: "translate(-3026.788 836.589)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path654",
    d: "M3587.244-1356.477c0-.136.11-1.6,2.344-1.68,0,0-1.1.13-1.289.614,0,0,.749-.6,1.358-.4s.967,1.26.971,1.611-.335,1.483-.722,1.579a1.163,1.163,0,0,1-.468,0,5.29,5.29,0,0,1,.3.536c.892,1.83-.028,3.618-.782,3.421-.485-.127-.621.7-.621.7l-4.7-3.808s1.728-3.575,3.613-2.568",
    transform: "translate(-3344.326 1416.124)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path656",
    d: "M3611.871-976.022l1,.372s4.34-6.018,4.874-11.312a8.057,8.057,0,0,0-.143-2.707s.042-.243.116-.671c.035-.2.076-.44.125-.716.141-.809.335-1.914.557-3.174.511-2.9,1.172-6.6,1.686-9.325l-.27-.087-2.913-.94-.6-1.912-2.169-.571s-.484.948-.918,5.425c-.079.587-.152,1.235-.207,1.937a38.279,38.279,0,0,0,.207,7.842c.1.778.225,1.582.38,2.407a10.745,10.745,0,0,1,.083,2.376,79.514,79.514,0,0,1-1.807,11.055",
    transform: "translate(-3370.59 1089.588)",
    fill: "#1c468a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path658",
    d: "M3628.125-999.7l4.709,9.362.125-.716c.141-.809.335-1.914.557-3.174.511-2.9,1.172-6.6,1.686-9.325l-.269-.087-2.912-.94-.6-1.912-2.169-.571s-.484.948-.918,5.425c-.079.588-.152,1.235-.207,1.937",
    transform: "translate(-3385.707 1089.588)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path660",
    d: "M3657.751-1020.347l.109-.935c1.827.485,6.707-1.356,6.707-1.356s1.769,1.556,1.537,5.284c-.113,1.819-.321,9.553-.538,11.84-.077.83-.146,1.419-.174,1.655v0a.323.323,0,0,0,.052.2,10.663,10.663,0,0,1,.8,1.679c2.123,5.658-.328,12.626-.328,12.626l-.636-.256s-1.394-7.755-2.527-11.18a6.779,6.779,0,0,0-.545-1.31,14.805,14.805,0,0,1-1.364-3.64,89.227,89.227,0,0,1-1.835-9.654c-.059,0-1.256-4.958-1.256-4.958",
    transform: "translate(-3413.261 1104.072)",
    fill: "#1c468a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path662",
    d: "M3470.285-1171.878l.136.915s.061,0,.167-.008c.333-.023,1.142-.068,2.057-.167a11.262,11.262,0,0,0,3.659-.779,14,14,0,0,0,3.674-4.308,1.061,1.061,0,0,0,.076-.136,6.641,6.641,0,0,0,.968-2.737,3.916,3.916,0,0,0-.128-1.239,3.168,3.168,0,0,0-.56-1.119.567.567,0,0,0-.105-.129,2.609,2.609,0,0,0-.718-.613c-.182-.076-.379.016-.583.235v.007a3.477,3.477,0,0,0-.521.771l-.015.022c-.039.068-.076.144-.122.227a.194.194,0,0,0-.03.053c-.083.173-.167.355-.25.545-.93,2.026-1.92,5.095-2.745,6.01a15.841,15.841,0,0,1-3.273,1.739c-.93.408-1.686.71-1.686.71",
    transform: "translate(-3238.907 1252.496)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path664",
    d: "M3607.858-1242.4a5.7,5.7,0,0,0,2.1.493c3.14.171,3.853-2.581,3.982-4.407a2.636,2.636,0,0,0-1.077-.137c-.223.013-.455.036-.647.059a4.817,4.817,0,0,1-1.473-2.805l-.135.062-2.266,1.065s.241.738.419,1.444a2.87,2.87,0,0,1,.155,1.235c-.178.072-.285.118-.285.118v0a15.588,15.588,0,0,0-.775,2.871",
    transform: "translate(-3366.857 1314.785)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path666",
    d: "M3593.134-1204.612c.023.063.05.124.078.187.8,1.712,2.268,8.807,2.268,8.807-.209,1.276,9.587-.25,9.612-1.412.345-1.231-1.225-3.21-2.109-4.2a2.852,2.852,0,0,1-.3-.4,2.786,2.786,0,0,1-.4-1.171,40.051,40.051,0,0,1-.122-4.128h0c-.174-.128-.341-.246-.5-.359a4.372,4.372,0,0,1-.6-.5.91.91,0,0,1-.29-.57,3.133,3.133,0,0,1,.012-.478c.007-.076.018-.152.029-.228a6.469,6.469,0,0,1,.455-1.52,5.9,5.9,0,0,0-2.341-.138s0,.084,0,.22a8.176,8.176,0,0,1-.175,2.219c-.22.331-4.233,1.781-4.446,1.333a8.115,8.115,0,0,1,.384-2.592v0a6.33,6.33,0,0,0-1.824.971c.81.525-.364,2.3.263,3.964",
    transform: "translate(-3352.919 1279.059)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path668",
    d: "M3614.831-1247.225s.242.737.419,1.443a2.915,2.915,0,0,0,1.848-2.508l-2.267,1.065",
    transform: "translate(-3373.343 1313.942)",
    fill: "#ed985f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path670",
    d: "M3584.058-1298.54s3.169-.733,2.681-2.7-.406-3.385-2.449-3-2.25,1.232-2.247,1.927,1.178,3.911,2.014,3.771",
    transform: "translate(-3342.849 1366.036)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path672",
    d: "M3577.62-1308.195c.341-.713.741-.674.992-.547a2.272,2.272,0,0,1,2.949-.253,3.87,3.87,0,0,0,1.78,1.913,2.7,2.7,0,0,1-1.9.488,2.331,2.331,0,0,1-1.258-.474,7.577,7.577,0,0,0,1.653,1.232c-1.766-.338-2.951-2.383-3.072-2.6a2.55,2.55,0,0,0-.46,1.088c-.032.54.153,1.588-.156,1.627,0,0-1.041-1.406-.53-2.474",
    transform: "translate(-3338.604 1370.803)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path674",
    d: "M3581.2-1179.224s-.763,1.331-.877,1.673a1.589,1.589,0,0,1,1.389.723s.1-2.217-.512-2.4",
    transform: "translate(-3341.25 1249.706)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path676",
    d: "M3656.316-1158.208c1.931-.021,3.568-2.026,4.568-3.631a2.793,2.793,0,0,1-.4-1.171,40.19,40.19,0,0,1-.122-4.128h0c-.173-.128-.34-.246-.5-.359a4.387,4.387,0,0,1-.6-.5c-1.583,2.675-5.565,9.817-2.945,9.789",
    transform: "translate(-3411.118 1239.265)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path678",
    d: "M3721.631-576.976h5.031a2.76,2.76,0,0,0-.142-1.349c-.252-.559-.646-.812-.552-1.487a1.81,1.81,0,0,1-1.568.6,5.527,5.527,0,0,1-.874,1.132c-.328.236-1.794.152-1.9,1.1",
    transform: "translate(-3472.673 692.22)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path680",
    d: "M3567.178-573.975h5.031a2.089,2.089,0,0,0-.142-1.349.97.97,0,0,1,.036-1.158,1.952,1.952,0,0,1-.847.159,1.766,1.766,0,0,1-.749-.263,18.085,18.085,0,0,1-1.434,1.506c-.328.236-1.795.152-1.9,1.1",
    transform: "translate(-3329.023 689.219)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path682",
    d: "M3557.618-1194.419l.2.781s2.513-.527,3.064-.648h.007c.945-.227,2-.5,2.9-.8a7.962,7.962,0,0,0,1.542-.688.946.946,0,0,0,.106-.075c.884-.643,1.935-2.533,2.752-4.559.113-.28.219-.56.325-.832a20.554,20.554,0,0,0,.863-2.873,8.207,8.207,0,0,0,.2-1.368,3.23,3.23,0,0,0,.007-.385c-.015-2.192-1.1-2.495-1.1-2.495a.7.7,0,0,0-.076-.023c-.189-.03-.386.1-.59.348a6.891,6.891,0,0,0-.809,1.429c-.431.975-.884,2.238-1.308,3.494-.235.687-.461,1.375-.688,2.011-.128.385-.257.748-.377,1.081a10.555,10.555,0,0,1-.635,1.474,3.688,3.688,0,0,1-.93.839c-.8.582-5.452,3.292-5.452,3.292",
    transform: "translate(-3320.131 1276.833)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path684",
    d: "M3691.911-1206.547a2.84,2.84,0,0,1,2.578.735c-.018-2.189-1.107-2.488-1.107-2.488-.439-.182-.947.577-1.471,1.753",
    transform: "translate(-3445.032 1276.774)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path686",
    d: "M3338-874.249l.566,4.5a.56.56,0,0,1-.541.7h-1.853a1.061,1.061,0,0,1-.944-.575l-2.956-5.217,5.727.589",
    transform: "translate(-3110.547 966.61)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path688",
    d: "M3295.515-953.651v2.031a.71.71,0,0,1-.707.708h-1.456a.71.71,0,0,1-.707-.708v-2.031a.709.709,0,0,1,.707-.707h1.456a.709.709,0,0,1,.707.707",
    transform: "translate(-3073.692 1040.568)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path690",
    d: "M3295.515-953.651v1.132a.709.709,0,0,1-.707.707h-1.456a.709.709,0,0,1-.707-.707v-1.132a.709.709,0,0,1,.707-.707h1.456a.709.709,0,0,1,.707.707",
    transform: "translate(-3073.692 1040.568)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path692",
    d: "M3334.486-1030.251a7.511,7.511,0,0,1-.6,2.936,7.588,7.588,0,0,1-6.964,4.625h-2.161a7.578,7.578,0,0,1-6.506-3.721,7.505,7.505,0,0,1-1.054-3.839,7.477,7.477,0,0,1,.6-2.935,7.584,7.584,0,0,1,6.963-4.625h2.161a7.578,7.578,0,0,1,6.613,3.907,7.488,7.488,0,0,1,.947,3.652",
    transform: "translate(-3096.534 1118.184)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path694",
    d: "M3333.539-1033.9a6.19,6.19,0,0,1-.191,2.778c-1.526,4.388-5.112,5.181-8.778,5.514a21.908,21.908,0,0,1-6.312-.8,7.505,7.505,0,0,1-1.054-3.839,7.477,7.477,0,0,1,.6-2.935,7.584,7.584,0,0,1,6.963-4.625h2.161a7.578,7.578,0,0,1,6.613,3.907",
    transform: "translate(-3096.534 1118.184)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path696",
    d: "M3365.789-1075.545h-2.974c-.3,0-.543-.183-.543-.407v-4.06a.325.325,0,0,1,.06-.187.65.65,0,0,1,.812-.136,5.847,5.847,0,0,1,3.187,4.356c.021.235-.227.435-.541.435",
    transform: "translate(-3138.449 1157.812)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path698",
    d: "M3362.936-1072.623h-.121c-.3,0-.543-.183-.543-.408v-4.06a.326.326,0,0,1,.06-.187.363.363,0,0,1,.036.036,5.087,5.087,0,0,1,1.315,4.111.7.7,0,0,1-.747.507",
    transform: "translate(-3138.449 1154.89)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path700",
    d: "M3349.352-977.821a.443.443,0,0,1,.443-.443.442.442,0,0,1,.443.443.443.443,0,0,1-.443.443.443.443,0,0,1-.443-.443",
    transform: "translate(-3126.432 1062.803)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path702",
    d: "M3464.857-881.346l-.705,4.579a.559.559,0,0,0,.54.7h1.853a1.062,1.062,0,0,0,.944-.575l2.88-5.745-5.511,1.039",
    transform: "translate(-3233.186 973.629)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path704",
    d: "M3549.286-957.056v0Zm3.258-.768a2.482,2.482,0,0,0-.452.432,2.412,2.412,0,0,0-.546,1.368c-.017.372.09.664.26.709s.421-.186.6-.564a2.786,2.786,0,0,0,.256-1.392A2.081,2.081,0,0,0,3552.543-957.823Zm-.688,2.826a.5.5,0,0,1-.128-.017c-.329-.087-.517-.479-.491-1.024a2.731,2.731,0,0,1,.614-1.548,2.8,2.8,0,0,1,.555-.52,1.582,1.582,0,0,0-.408-.45,1.052,1.052,0,0,0-.957-.2c-.916.248-1.693,1.557-1.755,1.7a.154.154,0,0,1-.195.094.155.155,0,0,1-.1-.2,4.524,4.524,0,0,1,.571-.86,2.948,2.948,0,0,1,1.338-1.026,1.363,1.363,0,0,1,1.281.234,1.918,1.918,0,0,1,.486.533,3.228,3.228,0,0,1,1.054-.36.155.155,0,0,1,.178.128.155.155,0,0,1-.128.178,2.9,2.9,0,0,0-.963.331,2.34,2.34,0,0,1,.165.7,3.064,3.064,0,0,1-.286,1.554c-.231.477-.535.746-.833.746",
    transform: "translate(-3312.102 1044.986)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path706",
    d: "M3415.327-1019.02a.142.142,0,0,1-.143.1.149.149,0,0,1-.034-.007,11.384,11.384,0,0,0-1.482-.351l-.048-.008c-.1-.017-.2-.033-.3-.047l-.144-.02c-.2-.027-.392-.048-.574-.064l-.146-.013-.112-.008-.261-.017a11.654,11.654,0,0,0-1.2-.013.14.14,0,0,1-.15-.132.141.141,0,0,1,.133-.15c.018,0,.355-.02.9,0l.192.008.04,0,.061,0,.168.01a13.919,13.919,0,0,1,1.551.185l.059.01.208.039.022,0a11.687,11.687,0,0,1,1.168.295.143.143,0,0,1,.093.177",
    transform: "translate(-3183.522 1101.397)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path708",
    d: "M3533.487-1012.7a12.414,12.414,0,0,0-1.528.693,3.18,3.18,0,0,0-.809,1.163s0,.137.132.137.415-.491.624-.412a4.236,4.236,0,0,1-.424.813,2.543,2.543,0,0,0-.215,1.169c.032.18,1.11-.675,1.561-1.064.24-.207.233-.71.308-1.277.065-.5,1.439-.786,1.439-.786l-1.089-.437",
    transform: "translate(-3295.516 1094.834)",
    fill: "#ffb27d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanding);
export default __webpack_public_path__ + "static/media/landing.9de468f4b593a596e35e130639e53cf0.svg";
export { ForwardRef as ReactComponent };